import React, { useEffect, useMemo, useState, useRef } from "react";
import { PlusOutlined, InboxOutlined, DeleteOutlined, FilePdfOutlined } from "@ant-design/icons";
import { fetchColor } from "features/jobinv/colorSlice";

import "./jobcardform.css";
import {
  Form,
  Input,
  Button,
  Radio,
  Select,
  Cascader,
  DatePicker,
  InputNumber,
  TreeSelect,
  Switch,
  Checkbox,
  Upload,
  Space,
  Row,
  Col,
  Slider,
  message,
  Divider,
  Skeleton,
  Modal,
} from "antd";
import styled from "styled-components";
import SelectType from "./SelectType";
import Title from "antd/lib/skeleton/Title";
import { useDispatch, useSelector } from "react-redux";
import {
  allDropDowns,
  // CreateJobCard,
  fetchClients,
  roleSelector,
  UpdateJobCard,
} from "features/jobinv/JobCardSlice";
import Loader from "components/common/Loader";
import moment from "moment/moment";
import { useForm } from "antd/es/form/Form";
import { ROLES, STAGES } from "components/common/Constants";
import ImageViewer from "components/ImageViewer";
import {
  useCreateCapMutation,
  useCreateJobcardMutation,
  useCreateJobcardVersionMutation,
  useFetchCapsQuery,
  useFetchColorsQuery,
  useFetchInventoryQuery,
  useFetchInventoryFilterOptionsQuery,
  useGetClientsQuery,
  useGetDropdownsQuery,
  useUpdateJobcardMutation,
  useFetchManufacture_capQuery,
  useUpdateManufacturerMutation,
  useGetManufacture_capQuery,
  useUploadJobcardImagesMutation,
  useDeleteJobcardImageMutation,
  useGetJobcardImageDetailQuery,
  useGetDigitizerUsersQuery,
} from "features/store";
import { getColorHex, extractColorName, normalizeHexColor } from "../../utils/identifyColor";
import { useNavigate } from "react-router-dom";
import useFormItemStatus from "antd/es/form/hooks/useFormItemStatus";
import { useDeferredValue } from "react";
import useFormInstance from "antd/lib/form/hooks/useFormInstance";
import { SyncLoader } from "react-spinners";
import { getImage } from "../../helper";
import { url } from "components/common/api";
import { PaymentFieldArray } from "components/State";
import { formatImageCreatedAt } from "../../utils/timezoneUtils";
import OutOfStockModal from "./OutOfStockModal";
const { RangePicker } = DatePicker;
const { Option } = Select;

// Technique options for each cap side
const TECHNIQUE_OPTIONS = [
  { label: "No Technique", value: "" },
  { label: "Airhole", value: "AIRHOLE" },
  { label: "Sublimation", value: "SUBLIMATION" },
];

const handleFormSubmit = (values, createJobcard, thisfun, statusofcap, colors) => {
  const formatedValues = {
    ...values,
    date: values.date?.format("YYYY-MM-DD") || "",
    deliver_date: values.deliver_date?.format("YYYY-MM-DD") || "",
    img1: values.img1?.target.files[0],
    main_image: values.main_image?.target?.files?.[0],
    img2: values.img2?.target.files[0],
    img3: values.img3?.target.files[0],
    img4: values.img4?.target.files[0],
    left_image: values.left_image?.target.files[0],
    right_image: values.right_image?.target.files[0],
    front_image: values.front_image?.target.files[0],
    color_image: values.color_image?.target.files[0],
    back_image: values.back_image?.target.files[0],
    current_stage: STAGES.CREATION,
  };
  // Build technique_map from per-side technique selects
  const technique_map = {
    front: values.technique_front || null,
    back: values.technique_back || null,
    middle: values.technique_middle || null,
    top: values.technique_top || null,
    under: values.technique_under || null,
    cross_band: values.technique_cross_band || null,
  };
  const anyTechnique = Object.values(technique_map).some((v) => v);
  if (anyTechnique) {
    formatedValues.technique_map = technique_map;
  }
  // Eyelet details: side-wise enable + selected color (id or name)
  // Only include color if the eyelet option includes "COLOR"
  const isEyeletFrontEnabled = typeof values.eyelet_front === 'string' && values.eyelet_front.toUpperCase().includes('COLOR');
  const isEyeletBackEnabled = typeof values.eyelet_back === 'string' && values.eyelet_back.toUpperCase().includes('COLOR');
  const isEyeletMiddleEnabled = typeof values.eyelet_middle === 'string' && values.eyelet_middle.toUpperCase().includes('COLOR');
  const eyelet_details = {
    front: {
      is_eyelet_enabled: Boolean(isEyeletFrontEnabled),
      color: isEyeletFrontEnabled ? (values.eyelet_front_color_sel ?? null) : null
    },
    back: {
      is_eyelet_enabled: Boolean(isEyeletBackEnabled),
      color: isEyeletBackEnabled ? (values.eyelet_back_color_sel ?? null) : null
    },
    middle: {
      is_eyelet_enabled: Boolean(isEyeletMiddleEnabled),
      color: isEyeletMiddleEnabled ? (values.eyelet_middle_color_sel ?? null) : null
    },
  };
  const anyEyelet = [eyelet_details.front, eyelet_details.back, eyelet_details.middle].some((s) => s.is_eyelet_enabled || s.color);
  if (anyEyelet) {
    formatedValues.eyelet_details = eyelet_details;
  }
  thisfun(formatedValues, false); // Not a duplication
};

// const handleFormUpdate = (values, updateJobcard) => {
//   const formatedValues = {
//     ...values,
//     date: values.date?.format("YYYY-MM-DD") || "",
//     deliver_date: values.deliver_date?.format("YYYY-MM-DD") || "",
//   };

//   //if no file selected; then no need to update the image
//   if (!values.img1?.target?.files?.length > 0) delete formatedValues.img1;
//   else {
//     formatedValues.img1 = values.img1?.target.files[0];
//   }
//   updateJobcard(formatedValues)

//   // delete formatedValues.img2;
//   // delete formatedValues.img3;
//   // delete formatedValues.img4;
//   // delete formatedValues.left_image;
//   // delete formatedValues.right_image;
//   // delete formatedValues.front_image;
//   // delete formatedValues.color_image;
//   // delete formatedValues.back_image;

//   // dispatch(updateJobcard(formatedValues));
// };
const handleFormUpdate = (values, updateJobcard, thisfun) => {
  const formatedValues = {
    ...values,
    date: values.date?.format("YYYY-MM-DD") || "",
    deliver_date: values.deliver_date?.format("YYYY-MM-DD") || "",
  };
  // Include technique_map on update as well
  const technique_map_update = {
    front: values.technique_front ?? null,
    back: values.technique_back ?? null,
    middle: values.technique_middle ?? null,
    top: values.technique_top ?? null,
    under: values.technique_under ?? null,
    cross_band: values.technique_cross_band ?? null,
  };
  // Always send technique_map during update to reflect clears
  formatedValues.technique_map = technique_map_update;
  // Eyelet details for update
  // Only include color if the eyelet option includes "COLOR"
  const isEyeletFrontEnabledU = typeof values.eyelet_front === 'string' && values.eyelet_front.toUpperCase().includes('COLOR');
  const isEyeletBackEnabledU = typeof values.eyelet_back === 'string' && values.eyelet_back.toUpperCase().includes('COLOR');
  const isEyeletMiddleEnabledU = typeof values.eyelet_middle === 'string' && values.eyelet_middle.toUpperCase().includes('COLOR');
  const eyelet_details_update = {
    front: {
      is_eyelet_enabled: Boolean(isEyeletFrontEnabledU),
      color: isEyeletFrontEnabledU ? (values.eyelet_front_color_sel ?? null) : null
    },
    back: {
      is_eyelet_enabled: Boolean(isEyeletBackEnabledU),
      color: isEyeletBackEnabledU ? (values.eyelet_back_color_sel ?? null) : null
    },
    middle: {
      is_eyelet_enabled: Boolean(isEyeletMiddleEnabledU),
      color: isEyeletMiddleEnabledU ? (values.eyelet_middle_color_sel ?? null) : null
    },
  };
  // Always send eyelet_details on update to ensure old values are cleared when needed
  // This ensures that when eyelet options change to non-color, the old color values are cleared
  formatedValues.eyelet_details = eyelet_details_update;
  if (!values.img1?.target?.files?.length > 0) delete formatedValues.img1;
  else formatedValues.img1 = values.img1?.target.files[0];
  if (!values.main_image?.target?.files?.length > 0) delete formatedValues.main_image;
  else formatedValues.main_image = values.main_image?.target.files[0];
  // Update manufactured cap (if applicable) and trigger jobcard update directly
  thisfun(formatedValues, false); // Not a duplication
  updateJobcard(formatedValues);
};

const JobCardForm = ({ formValues, autoFocusDigitizer }) => {
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [addressType, setAddressType] = useState('shipping');
  const [render, setRender] = useState(false);
  const navigate = useNavigate();
  // const { loading } = useSelector((state) => state.JobCard);
  // const {selections, error } = useSelector((state) => state.JobCard);
  const [form] = Form.useForm();
  const { data: selections, isLoading: dropdownLoading } =
    useGetDropdownsQuery();

  const { data: clients, isLoading: loading } = useGetClientsQuery();
  const { data: digitizers, isLoading: digitizersLoading } = useGetDigitizerUsersQuery();
  const colorx = useSelector((state) => state.color);

  // to get colors send cloth__cloth_type e.g Flexi stock
  const [a, setA] = useState(null);
  const shouldFetchColors = true
  const { data: colorss, isFetching: colorloading } = useFetchColorsQuery({
    skip: a, // existing colors fetch used by other parts of the form
  });
  const [colors, setcolors] = useState();
  // const { data: colors, isLoading: colorloading } = useFetchCapsQuery({

  // });
  const colorf = useSelector((state) => state.color);



  useEffect(() => {
    if (a !== null) {


      setcolors(colorss)
    }
  }, [a, colorss]);

  const digitizerSelectRef = useRef(null);
  const [digitizerDropdownOpen, setDigitizerDropdownOpen] = useState(false);

  useEffect(() => {
    if (autoFocusDigitizer) {
      setTimeout(() => {
        setDigitizerDropdownOpen(true);
        if (digitizerSelectRef.current) {
          digitizerSelectRef.current.focus();
        }
      }, 500);
    }
  }, [autoFocusDigitizer]);
  // Unique eyelet color options by normalized color name (case-insensitive)
  const uniqueEyeletColors = useMemo(() => {
    const source = colors; // revert to using general colors list
    if (!source || !Array.isArray(source)) return [];
    const seen = new Map();
    for (const it of source) {
      const name = extractColorName(it?.color ?? '');
      const key = String(name || '').trim().toLowerCase();
      if (!key) continue;
      if (!seen.has(key)) {
        seen.set(key, it);
      }
    }
    return Array.from(seen.values());
  }, [colors]);
  const [for_counter, setFor_counter] = useState(0);

  const getCapName = (data) => {
    // console.log(formValues?.style)

    if (formValues && formValues?.style && for_counter === 0) {
      setA(formValues?.style);
      setFor_counter(1);
    } else {
      if (data === "BUCKET HAT") {
        setA("BUCKET HAT");
      } else if (data === "	5 PART CAP") {
        setA("5 PART CAP");
      } else {
        // setA("BASE BALL CAP");
        setA(data);
      }
    }
  };

  useEffect(() => {
    console.log("cap", a);
  }, [a]);
  const f1 = "FRONT";
  const f2 = "BACK";
  const f3 = "MIDDLE";
  const f4 = "TOP";
  const f5 = "UNDER";
  const f6 = "PIPING";
  const f9 = "BRIM_TOP";
  const f10 = "BRIM_UNDER";
  const f13 = "CROSS_BAND";
  const visor = colors
    ? [...new Set(colors?.filter(item => item?.cap_material === "VISOR TYPE"))]
    : [];
  console.log(visor);
  const capSideTypes = [];
  visor.forEach((item) => {
    if (item.cap_data !== null) {
      item.cap_data?.forEach((capItem) => {
        if (capItem.cap_type === a) {
          capSideTypes.push({
            color: item.color,
            type: item.type,
          });
        }
      });
    }
  });
  const tyeps = capSideTypes.map((it) => it.type + " : " + it.color);

  // Inventory-backed quantities for Visor Type (preserve original values from `tyeps`)
  const { data: visorInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "VISOR TYPE",
    page_size: 1000,
  });
  const visor_type_options = useMemo(() => {
    const inv = Array.isArray(visorInventory)
      ? visorInventory
      : visorInventory?.results || [];
    // Aggregate by type+color and color-only fallbacks
    const byTypeColor = new Map();
    const byColorOnly = new Map();
    for (const row of inv) {
      const type = row?.color_cloth?.type;
      const color = row?.color_cloth?.color;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      const add = isNaN(num) ? 0 : num;
      const colorKey = String(color).trim().toLowerCase();
      byColorOnly.set(colorKey, (byColorOnly.get(colorKey) || 0) + add);
      if (type !== undefined) {
        const key = `${type} : ${color}`;
        byTypeColor.set(key, (byTypeColor.get(key) || 0) + add);
      }
    }
    // Map over allowed values (tyeps) and attach qty
    return (tyeps || []).map((labelStr) => {
      let qty = byTypeColor.get(labelStr);
      if (qty === undefined || qty === null) {
        const colorMatch = /:\s*(.*)$/.exec(String(labelStr));
        if (colorMatch) {
          const colorOnly = colorMatch[1]?.trim();
          const ck = String(colorOnly || '').toLowerCase();
          if (ck) qty = byColorOnly.get(ck);
        }
      }
      return { label: labelStr, value: labelStr, qty };
    });
  }, [visorInventory, tyeps]);

  const sweat = [
    ...new Set(
      colors?.filter(
        (item) => item.cap_material === "SWEATE BAND," && item.color === null
      )
    ),
  ];

  const result = colors
    ?.filter((item) => item.cap_material === "SWEATE BAND" && item.cap_data)
    .map((item) => {
      const capData = item.cap_data?.find((capItem) => capItem.cap_type === a);
      if (capData) {
        return {
          type: item.type,
          color: item.color,
        };
      }
    })
    .filter(Boolean);
  console.log("lion", result);

  const sweat_band = result?.map((it) => it.type + " : color = " + it.color);

  // Inventory-backed quantities for Sweatband options (keeps original values intact)
  const { data: sweatInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "SWEATE BAND",
    page_size: 1000,
  });
  const sweat_band_options = useMemo(() => {
    const inv = Array.isArray(sweatInventory)
      ? sweatInventory
      : sweatInventory?.results || [];
    if (!Array.isArray(sweat_band) || !sweat_band.length) return sweat_band || [];

    // Build quantity maps
    const byTypeColor = new Map(); // key = `type : color = color`
    const byColorOnly = new Map(); // key = lower(color)
    for (const row of inv) {
      const type = row?.color_cloth?.type;
      const color = row?.color_cloth?.color;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      const add = isNaN(num) ? 0 : num;
      const colorKey = String(color).trim().toLowerCase();
      byColorOnly.set(colorKey, (byColorOnly.get(colorKey) || 0) + add);
      if (type !== undefined) {
        const key = `${type} : color = ${color}`;
        byTypeColor.set(key, (byTypeColor.get(key) || 0) + add);
      }
    }

    // Return option objects with qty while preserving original value format.
    // If exact `type : color = ...` not found, fallback to color-only aggregate.
    return sweat_band.map((labelStr) => {
      let qty = byTypeColor.get(labelStr);
      if (qty === undefined || qty === null) {
        const colorMatch = /color\s*=\s*(.*)$/i.exec(String(labelStr));
        if (colorMatch) {
          const colorOnly = colorMatch[1]?.trim();
          const ck = String(colorOnly || '').toLowerCase();
          if (ck) qty = byColorOnly.get(ck);
        }
      }
      return { label: labelStr, value: labelStr, qty };
    });
  }, [sweatInventory, sweat_band]);

  // Inventory-backed quantities for Elastic, Interlining, and Full Closure Elastic
  const { data: elasticInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "ELASTIC",
    page_size: 1000,
  });
  const { data: interliningInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "INTERLINING",
    page_size: 1000,
  });
  const { data: fullElasticInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "FULL CLOSURE ELASTIC",
    page_size: 1000,
  });

  const buildColorOptionsFromInventory = (inventoryData, fallbackColorList) => {
    const inv = Array.isArray(inventoryData)
      ? inventoryData
      : inventoryData?.results || [];
    const byColor = new Map();
    for (const row of inv) {
      const color = row?.color_cloth?.color;
      const color_code = row?.color_cloth?.color_code || null;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const key = String(color).trim().toLowerCase();
      const prev = byColor.get(key) || { label: color, value: color, qty: 0, color_code };
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      prev.qty = (prev.qty || 0) + (isNaN(num) ? 0 : num);
      if (!prev.color_code && color_code) prev.color_code = color_code;
      byColor.set(key, prev);
    }
    // Fallback: include colors found in existing dataset so dropdowns don't go empty
    (fallbackColorList || []).forEach((c) => {
      const key = String(c || '').trim().toLowerCase();
      if (!key) return;
      if (!byColor.has(key)) byColor.set(key, { label: c, value: c });
    });
    return Array.from(byColor.values());
  };

  const elastic_color_options = useMemo(() => {
    const fallback = colors
      ?.filter((item) => item?.cap_material === "ELASTIC" && item.cap_data?.some((it) => it.cap_type === a))
      ?.map((op) => op.color) || [];
    return buildColorOptionsFromInventory(elasticInventory, fallback);
  }, [elasticInventory, colors, a]);

  const interlining_color_options = useMemo(() => {
    const fallback = colors
      ?.filter((item) => item?.cap_material === "INTERLINING" && item.cap_data?.some((it) => it.cap_type === a))
      ?.map((op) => op.color) || [];
    return buildColorOptionsFromInventory(interliningInventory, fallback);
  }, [interliningInventory, colors, a]);

  const full_elastic_color_options = useMemo(() => {
    const fallback = colors
      ?.filter((item) => item?.cap_material === "FULL CLOSURE ELASTIC" && item.cap_data?.some((it) => it.cap_type === a))
      ?.map((op) => op.color) || [];
    return buildColorOptionsFromInventory(fullElasticInventory, fallback);
  }, [fullElasticInventory, colors, a]);

  const fushing = colors
    ?.filter((item) => item.cap_material === "FUSING" && item.cap_data)
    .map((item) => {
      const capData = item.cap_data?.find((capItem) => capItem.cap_type === a);
      if (capData) {
        return {
          type: item.type,
          color: item.color,
        };
      }
    })
    .filter(Boolean);

  const taper_data = colors
    ?.filter((item) => item.cap_material === "TAPER" && item.cap_data)
    .map((item) => {
      const capData = item.cap_data?.find((capItem) => capItem.cap_type === a);
      if (capData) {
        return {
          type: item.type,
          color: item.color,
        };
      }
    })
    .filter(Boolean);








  const back_closer = colors
    ?.filter((item) => item.cap_material === "BACK CLOSER" && item.cap_data)
    .map((item) => {
      const capData = item.cap_data?.find((capItem) => capItem.cap_type === a);
      if (capData) {
        return {
          type: item.type,
          quantity: capData.quantity,
        };
      }
    })
    .filter(Boolean);

  const back_closer_data = [...new Set(back_closer?.map((it) => it.type))];
  const cloth_type = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_type === a;
          });
        })
        .map((item) => item.type)
    ),
  ];

  // console.log(cloth_type)
  console.log("closer", back_closer_data);

  const [back_closer_colors, setBack_closer_colors] = useState([]);
  const [back_closer_type, setBack_closer] = useState([]);

  // Fetch inventory for Back Closer by selected type to derive accurate quantities
  const { data: backCloserInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "BACK CLOSER",
    sub_type: back_closer_type || undefined,
    page_size: 1000,
  });

  const backCloserColorOptions = useMemo(() => {
    const data = Array.isArray(backCloserInventory)
      ? backCloserInventory
      : backCloserInventory?.results || [];
    if (!data || !data.length) return [];

    // Aggregate quantities per color
    const byColor = new Map();
    for (const rec of data) {
      const color = rec?.color_cloth?.color;
      if (!color) continue;
      const key = String(color).trim().toLowerCase();
      const qtyVal = rec?.quantity;
      const qtyNum = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      const colorCode = rec?.color_cloth?.color_code || null;
      const prev = byColor.get(key) || { label: color, value: color, color_code: colorCode, qty: 0 };
      const add = isNaN(qtyNum) ? 0 : qtyNum;
      prev.qty = (prev.qty || 0) + add;
      // Prefer non-null color_code if available later
      if (!prev.color_code && colorCode) prev.color_code = colorCode;
      byColor.set(key, prev);
    }
    return Array.from(byColor.values());
  }, [backCloserInventory]);

  useEffect(() => {
    setBack_closer_colors(backCloserColorOptions);
  }, [backCloserColorOptions]);

  const getCloser = (value) => {
    setBack_closer(value);
  };

  const [for_closer, setFor_closer] = useState();
  const [for_piping, setFor_piping] = useState();

  const getCloser_color = (value) => {




    const filteredItems = colors?.filter(
      (item) => item.type === back_closer_type && item.color === value
    );

    // Extract the id and cap_data?.id values from the filtered items
    const result = filteredItems.map((item) => ({
      cloth_id: item.id,
      cap_id: item.cap_data[0].id,
    }));

    console.log(result);
    if (formValues) {
      console.log();
      function findCapMaterialWithVisorType(data) {
        for (const item of data.manufacturedcapdata_set) {
          const capMaterial = item.cap_material;
          if (capMaterial && capMaterial.cap_material === "BACK CLOSER") {
            return item.id;
          }
        }
        return null; // Return null if no cap material with visor type found
      }

      const visorTypeId = findCapMaterialWithVisorType(
        manufacture_capdata?.filter(
          (item) => item.id === formValues?.manufacture_cap
        )[0]
      );
      console.log("Visor Type ID:", visorTypeId);

      if (visorTypeId) {
        result[0].id = visorTypeId;
      }
    }
    console.log(result[0]);

    setFor_closer(result[0]);
  };

  const foam_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "FOAM"
    )
    .map((ite) => ite.color);

  const nonon_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "NONON"
    )
    .map((ite) => ite.color);
  const buckle_belt_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "BUCKLE BELT"
    )
    .map((ite) => ite.color);

  const buckle_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "BUCKLE"
    )
    .map((ite) => ite.type);



  const binder_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "BINDER"
    )
    .map((ite) => ite.color);
  const button_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "BUTTON"
    )
    .map((ite) => ite.color);

  const brim_foam_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "BRIM FOAM"
    )
    .map((ite) => ite.color);

  const o_ring_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "O-RING"
    )
    .map((ite) => ite.color);
  const snappack_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "SNAPACK"
    )
    .map((ite) => ite.color);
  const sweat_band_holding_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "SWEAT BAND HOLDING"
    )
    .map((ite) => ite.color);
  const sizing_strip = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "SIZING STRIP"
    )
    .map((ite) => ite.color);
  // Inventory-backed options for SIZING STRIP (preserve original value=COLOR)
  const { data: sizingStripInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "SIZING STRIP",
    page_size: 1000,
  });
  const sizing_strip_options = useMemo(() => {
    const inv = Array.isArray(sizingStripInventory)
      ? sizingStripInventory
      : sizingStripInventory?.results || [];
    // Aggregate by color only
    const byColor = new Map();
    for (const row of inv) {
      const color = row?.color_cloth?.color;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const key = String(color).trim().toLowerCase();
      const prev = byColor.get(key) || { label: color, value: color, qty: 0 };
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      prev.qty = (prev.qty || 0) + (isNaN(num) ? 0 : num);
      byColor.set(key, prev);
    }
    // Include any colors from existing list that might not be in inventory
    if (Array.isArray(sizing_strip)) {
      for (const c of sizing_strip) {
        const key = String(c || '').trim().toLowerCase();
        if (!key) continue;
        if (!byColor.has(key)) byColor.set(key, { label: c, value: c });
      }
    }
    return Array.from(byColor.values());
  }, [sizingStripInventory, sizing_strip]);
  const carton_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "CARTON"
    )
    .map((ite) => ite.type);
  const plastic_bag_data = colors
    ?.filter(
      (item) =>
        item.cap_data &&
        item.cap_data?.some((it) => it.cap_type === a) &&
        item.cap_material === "PLASTIC BAG"
    )
    .map((ite) => ite.type);

  const fushing_data = fushing?.map(
    (it) => it.type + " : color = " + it.color
  );
  const taper_data_extract = taper_data?.map(
    (it) => it.type + " : color = " + it.color
  );

  // Inventory-backed quantities for Fusing and Taper (preserve existing values)
  const { data: fusingInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "FUSING",
    page_size: 1000,
  });
  const { data: taperInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "TAPER",
    page_size: 1000,
  });

  const fusing_options = useMemo(() => {
    const inv = Array.isArray(fusingInventory)
      ? fusingInventory
      : fusingInventory?.results || [];
    const byTypeColor = new Map();
    const byColorOnly = new Map();
    for (const row of inv) {
      const type = row?.color_cloth?.type;
      const color = row?.color_cloth?.color;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      const add = isNaN(num) ? 0 : num;
      const colorKey = String(color).trim().toLowerCase();
      byColorOnly.set(colorKey, (byColorOnly.get(colorKey) || 0) + add);
      if (type !== undefined) {
        const key = `${type} : color = ${color}`;
        byTypeColor.set(key, (byTypeColor.get(key) || 0) + add);
      }
    }
    return (fushing_data || []).map((labelStr) => {
      let qty = byTypeColor.get(labelStr);
      if (qty === undefined || qty === null) {
        const m = /color\s*=\s*(.*)$/i.exec(String(labelStr));
        if (m) {
          const colorOnly = m[1]?.trim();
          const ck = String(colorOnly || '').toLowerCase();
          if (ck) qty = byColorOnly.get(ck);
        }
      }
      return { label: labelStr, value: labelStr, qty };
    });
  }, [fusingInventory, fushing_data]);

  const taper_options = useMemo(() => {
    const inv = Array.isArray(taperInventory)
      ? taperInventory
      : taperInventory?.results || [];
    const byTypeColor = new Map();
    const byColorOnly = new Map();
    for (const row of inv) {
      const type = row?.color_cloth?.type;
      const color = row?.color_cloth?.color;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      const add = isNaN(num) ? 0 : num;
      const colorKey = String(color).trim().toLowerCase();
      byColorOnly.set(colorKey, (byColorOnly.get(colorKey) || 0) + add);
      if (type !== undefined) {
        const key = `${type} : color = ${color}`;
        byTypeColor.set(key, (byTypeColor.get(key) || 0) + add);
      }
    }
    return (taper_data_extract || []).map((labelStr) => {
      let qty = byTypeColor.get(labelStr);
      if (qty === undefined || qty === null) {
        const m = /color\s*=\s*(.*)$/i.exec(String(labelStr));
        if (m) {
          const colorOnly = m[1]?.trim();
          const ck = String(colorOnly || '').toLowerCase();
          if (ck) qty = byColorOnly.get(ck);
        }
      }
      return { label: labelStr, value: labelStr, qty };
    });
  }, [taperInventory, taper_data_extract]);

  const cloth_type1 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f1 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];

  const cloth_type2 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f2 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];
  const cloth_type3 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f3 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];
  const cloth_type4 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f4 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];
  const cloth_type5 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f5 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];
  const cloth_type6 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return (
            item?.cap_material === "PIPING" &&

            item.cap_data?.some((cap) => {
              return cap.cap_type === a;
            })
          );
        })
        .map((item) => item.type)
        .filter((op) => op !== null)
    ),
  ];



  const cloth_type9 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f9 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];

  const cloth_type10 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f10 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];

  const cloth_type13 = [
    ...new Set(
      colors
        ?.filter((item) => {
          return item.cap_data?.some((cap) => {
            return cap.cap_side_type === f13 && cap.cap_type === a;
          });
        })
        .map((item) => item.cloth_type)
    ),
  ];

  const [q_tity, setQ_tity] = useState(1);
  const [cap_M, setCap_M] = useState();
  const [formval, setFormval] = useState();
  const [createCap, creatCapResponseInfo] = useCreateCapMutation();
  const [topid, setTopid] = useState();
  const [update_fronttype, setupdate_fronttype] = useState();
  const [update_backtype, setupdate_backtype] = useState();
  const [update_middle, setupdate_middle] = useState();
  const [update_top, setupdate_top] = useState();
  const [update_under, setupdate_under] = useState();
  const [update_brimtop, setupdate_brimtop] = useState();
  const [update_brimunder, setupdate_brimunder] = useState();
  const [update_crossband, setupdate_crossband] = useState();
  const [man_id, setMan_id] = useState();
  const { data: manufacture_capdata, isLoading: manufacture_caploading } =
    useGetManufacture_capQuery({ id: formValues?.manufacture_cap });
  // console.log(creatCapResponseInfo)
  //  console.log(manufacture_capdata.filter((item)=>item.id===71))
  useEffect(() => {
    if (formValues) {

      console.log(manufacture_caploading);
      console.log("make it effect");



      if (manufacture_caploading === false) {
        if (manufacture_capdata && formValues) {
          setQ_tity(formValues?.quantity);

          console.log("formValue", formValues?.quantity);

          console.log(
            "manu",
            manufacture_capdata
          );

          setTopid(
            manufacture_capdata?.id
          );
          // setTopid(
          //   manufacture_capdata.id
          // );

          // console.log(formValues?.manufacture_cap)


          if (a === "BUCKET HAT" || a === "REVERSIBLE BUCKET HAT") {
            const targetData = manufacture_capdata;
            console.log("tigerssssss", targetData);

            let front = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "FRONT");
              if (desiredCapData) {
                front = desiredCapData.id;
              }
            }
            setupdate_fronttype(front);

            let top = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "TOP");
              if (desiredCapData) {
                top = desiredCapData.id;
              }
            }
            setupdate_top(top);

            let brimTop = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "BRIM_TOP");
              if (desiredCapData) {
                brimTop = desiredCapData.id;
              }
            }
            setupdate_brimtop(brimTop);

            let brimUnder = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "BRIM_UNDER");
              if (desiredCapData) {
                brimUnder = desiredCapData.id;
              }
            }
            setupdate_brimunder(brimUnder);

            let crossBand = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "CROSS_BAND");
              if (desiredCapData) {
                crossBand = desiredCapData.id;
              }
            }
            setupdate_crossband(crossBand);
          } else if (a === "UMPIRE HAT") {
            const targetData = manufacture_capdata;

            let front = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "FRONT");
              if (desiredCapData) {
                front = desiredCapData.id;
              }
            }
            setupdate_fronttype(front);

            let top = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "TOP");
              if (desiredCapData) {
                top = desiredCapData.id;
              }
            }
            setupdate_top(top);

            let brimTop = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "BRIM_TOP");
              if (desiredCapData) {
                brimTop = desiredCapData.id;
              }
            }
            setupdate_brimtop(brimTop);

            let brimUnder = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "BRIM_UNDER");
              if (desiredCapData) {
                brimUnder = desiredCapData.id;
              }
            }
            setupdate_brimunder(brimUnder);

            const filteredData1 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "FRONT"
            );
            const capIds1 = filteredData1?.map(item => item.cap);
            const clothIds1 = filteredData1?.map(item => item.cap_material.id);
            setCap_data_id1(capIds1[0]);
            setcloth_id1(clothIds1[0]);

            const filteredData4 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "TOP"
            );
            const capIds4 = filteredData4?.map(item => item.cap);
            const clothIds4 = filteredData4?.map(item => item.cap_material.id);
            setCap_data_id4(capIds4[0]);
            setcloth_id4(clothIds4[0]);

            const filteredData9 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "BRIM_TOP"
            );
            const capIds9 = filteredData9?.map(item => item.cap);
            const clothIds9 = filteredData9?.map(item => item.cap_material.id);
            setCap_data_id9(capIds9[0]);
            setcloth_id9(clothIds9[0]);

            const filteredData10 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "BRIM_UNDER"
            );
            const capIds10 = filteredData10?.map(item => item.cap);
            const clothIds10 = filteredData10?.map(item => item.cap_material.id);
            setCap_data_id10(capIds10[0]);
            setcloth_id10(clothIds10[0]);
          } else if (a === "BUCKET HAT" || a === "REVERSIBLE BUCKET HAT") {
            const targetData = manufacture_capdata;

            const filteredData1 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "FRONT"
            );
            const capIds1 = filteredData1?.map(item => item.cap);
            const clothIds1 = filteredData1?.map(item => item.cap_material.id);
            setCap_data_id1(capIds1[0]);
            setcloth_id1(clothIds1[0]);

            const filteredData4 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "TOP"
            );
            const capIds4 = filteredData4?.map(item => item.cap);
            const clothIds4 = filteredData4?.map(item => item.cap_material.id);
            setCap_data_id4(capIds4[0]);
            setcloth_id4(clothIds4[0]);

            const filteredData9 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "BRIM_TOP"
            );
            const capIds9 = filteredData9?.map(item => item.cap);
            const clothIds9 = filteredData9?.map(item => item.cap_material.id);
            setCap_data_id9(capIds9[0]);
            setcloth_id9(clothIds9[0]);

            const filteredData10 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "BRIM_UNDER"
            );
            const capIds10 = filteredData10?.map(item => item.cap);
            const clothIds10 = filteredData10?.map(item => item.cap_material.id);
            setCap_data_id10(capIds10[0]);
            setcloth_id10(clothIds10[0]);

            const filteredData13 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "CROSS_BAND"
            );
            const capIds13 = filteredData13?.map(item => item.cap);
            const clothIds13 = filteredData13?.map(item => item.cap_material.id);
            setCap_data_id13(capIds13[0]);
            setcloth_id13(clothIds13[0]);













            // setCap_data_id1(
            //   manufacture_capdata &&
            //     manufacture_capdata?.filter(
            //       (item) => item?.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[0]?.cap
            // );

            // setCap_data_id4(
            //   manufacture_capdata &&
            //     manufacture_capdata?.filter(
            //       (item) => item?.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[1]?.cap
            // );
            // setCap_data_id5(
            //   manufacture_capdata &&
            //     manufacture_capdata?.filter(
            //       (item) => item?.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[2]?.cap
            // );

            // setcloth_id1(
            //   manufacture_capdata &&
            //     manufacture_capdata.filter(
            //       (item) => item.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[0]?.cap_material?.id
            // );


            // setcloth_id4(
            //   manufacture_capdata &&
            //     manufacture_capdata.filter(
            //       (item) => item.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[1]?.cap_material?.id
            // );
            // setcloth_id5(
            //   manufacture_capdata &&
            //     manufacture_capdata.filter(
            //       (item) => item.id === formValues?.manufacture_cap
            //     )[0].manufacturedcapdata_set[2]?.cap_material?.id
            // );
          } else {


            const targetData = manufacture_capdata;
            console.log("tigerssssss", targetData)

            let desiredManufacturedCapDataId = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "FRONT");
              if (desiredCapData) {
                desiredManufacturedCapDataId = desiredCapData.id;
              }
            }
            setupdate_fronttype(desiredManufacturedCapDataId)
            let back = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "BACK");
              if (desiredCapData) {
                back = desiredCapData.id;
              }
            }
            setupdate_backtype(back)
            let middle = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "MIDDLE");
              if (desiredCapData) {
                middle = desiredCapData.id;
              }
            }
            setupdate_middle(middle)

            let top = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "TOP");
              if (desiredCapData) {
                top = desiredCapData.id;
              }
            }
            setupdate_top(
              top
            );
            let under = null;
            if (targetData) {
              const desiredCapData = targetData?.manufacturedcapdata_set.find(item => item.cap_side_type === "UNDER");
              if (desiredCapData) {
                under = desiredCapData.id;
              }
            }
            setupdate_under(
              under
            );








            const filteredData1 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "FRONT"
            );

            const capIds1 = filteredData1?.map(item => item.cap);
            const clothIds1 = filteredData1?.map(item => item.cap_material.id);


            setCap_data_id1(capIds1[0])
            setcloth_id1(clothIds1[0])




            const filteredData2 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "BACK"
            );

            const capIds2 = filteredData2.map(item => item.cap);
            const clothIds2 = filteredData2.map(item => item.cap_material.id);

            setCap_data_id2(capIds2[0])
            setcloth_id2(clothIds2[0])

            const filteredData3 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "MIDDLE"
            );

            const capIds3 = filteredData3.map(item => item.cap);
            const clothIds3 = filteredData3.map(item => item.cap_material.id);

            setCap_data_id3(capIds3[0])
            setcloth_id3(clothIds3[0])

            const filteredData4 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "TOP"
            );

            const capIds4 = filteredData4.map(item => item.cap);
            const clothIds4 = filteredData4.map(item => item.cap_material.id);

            setCap_data_id4(capIds4[0])
            setcloth_id4(clothIds4[0])

            const filteredData5 = targetData?.manufacturedcapdata_set.filter(
              item => item.cap_side_type === "UNDER"
            );

            const capIds5 = filteredData5.map(item => item.cap);
            const clothIds5 = filteredData5.map(item => item.cap_material.id);

            setCap_data_id5(capIds5[0])
            setcloth_id5(clothIds5[0])






          }
        }
      }
    }

  }, [manufacture_capdata]);

  const thisfun = async (formatedValues, isDuplication = false) => {
    const result = [];

    const shouldInclude = (v) =>
      v !== null && v !== undefined && (!Array.isArray(v) || v.length > 0);

    if (shouldInclude(visior)) result.push(visior);
    if (shouldInclude(fusing)) result.push(fusing);
    if (shouldInclude(taper_obj)) result.push(taper_obj);
    if (shouldInclude(sweat_bands)) result.push(sweat_bands);
    if (shouldInclude(for_closer)) result.push(for_closer);
    if (shouldInclude(for_piping)) result.push(for_piping);
    if (shouldInclude(foam)) result.push(foam);
    if (shouldInclude(strip_obj)) result.push(strip_obj);
    if (shouldInclude(binder_obj)) result.push(binder_obj);
    if (shouldInclude(nonon)) result.push(nonon);
    if (shouldInclude(bulkle_belt_obj)) result.push(bulkle_belt_obj);
    if (shouldInclude(bulkle_obj)) result.push(bulkle_obj);
    if (shouldInclude(interLINING)) result.push(interLINING);
    if (shouldInclude(elastic_obj)) result.push(elastic_obj);
    if (shouldInclude(full_closer_obj)) result.push(full_closer_obj);
    if (shouldInclude(brim_foam_obj)) result.push(brim_foam_obj);
    if (shouldInclude(carton_obj)) result.push(carton_obj);
    if (shouldInclude(plastic_obj)) result.push(plastic_obj);
    if (shouldInclude(o_ring_obj)) result.push(o_ring_obj);
    if (shouldInclude(snappack_obj)) result.push(snappack_obj);
    if (shouldInclude(sweat_band_holding_obj)) result.push(sweat_band_holding_obj);

    console.log("qqqqqqqqq", q_tity);
    setFormval(formatedValues);

    if (a === "BUCKET HAT" || a === "REVERSIBLE BUCKET HAT") {
      const r = {
        cap_type: a,
        manufacture_quantity: q_tity,
        manufactured_cap_data: [
          { cap_id: cap_data_id1, cloth_id: cloth_id1 },
          { cap_id: cap_data_id4, cloth_id: cloth_id4 },
          { cap_id: cap_data_id9, cloth_id: cloth_id9 },
          { cap_id: cap_data_id10, cloth_id: cloth_id10 },
          { cap_id: cap_data_id13, cloth_id: cloth_id13 },
        ],
      };
      r.manufactured_cap_data?.push(...result);

      if (!formValues || isDuplication) {
        r.manufactured_cap_data = r.manufactured_cap_data?.filter(
          (cap) => cap.length !== 0,
        );
        const filteredData = {
          ...r,
          manufactured_cap_data: r.manufactured_cap_data?.filter(
            (item) =>
              item.cap_id !== null &&
              item.cloth_id !== null &&
              item.cap_id !== undefined,
          ),
        };
        createCap(filteredData);
      }
    } else if (a === "UMPIRE HAT") {
      const r = {
        cap_type: a,
        manufacture_quantity: q_tity,
        manufactured_cap_data: [
          { cap_id: cap_data_id1, cloth_id: cloth_id1 },
          { cap_id: cap_data_id4, cloth_id: cloth_id4 },
          { cap_id: cap_data_id9, cloth_id: cloth_id9 },
          { cap_id: cap_data_id10, cloth_id: cloth_id10 },
        ],
      };
      r.manufactured_cap_data?.push(...result);

      if (!formValues || isDuplication) {
        r.manufactured_cap_data = r.manufactured_cap_data?.filter(
          (cap) => cap.length !== 0,
        );
        const filteredData = {
          ...r,
          manufactured_cap_data: r.manufactured_cap_data?.filter(
            (item) =>
              item.cap_id !== null &&
              item.cloth_id !== null &&
              item.cap_id !== undefined,
          ),
        };
        createCap(filteredData);
      }
    } else {
      const r = {
        cap_type: a,
        manufacture_quantity: q_tity,
        manufactured_cap_data: [
          { cap_id: cap_data_id1, cloth_id: cloth_id1 },
          { cap_id: cap_data_id2, cloth_id: cloth_id2 },
          { cap_id: cap_data_id3, cloth_id: cloth_id3 },
          { cap_id: cap_data_id4, cloth_id: cloth_id4 },
          { cap_id: cap_data_id5, cloth_id: cloth_id5 },
        ],
      };
      r.manufactured_cap_data?.push(...result);

      if (!formValues || isDuplication) {
        r.manufactured_cap_data = r.manufactured_cap_data?.filter(
          (cap) => cap.length !== 0,
        );
        const filteredData = {
          ...r,
          manufactured_cap_data: r.manufactured_cap_data?.filter(
            (item) =>
              item.cap_id !== null &&
              item.cloth_id !== null &&
              item.cap_id !== undefined,
          ),
        };
        createCap(filteredData);
      }
    }

    if (formValues && !isDuplication) {
      // Existing update logic for non-duplication cases
      if (a === "BUCKET HAT" || a === "REVERSIBLE BUCKET HAT") {
        const r_updatte = {
          id: topid,
          cap_type: a,
          manufacture_quantity: q_tity,
          manufactured_cap_data: [
            { id: update_fronttype, cap_id: cap_data_id1, cloth_id: cloth_id1 },
            { id: update_top, cap_id: cap_data_id4, cloth_id: cloth_id4 },
            { id: update_brimtop, cap_id: cap_data_id9, cloth_id: cloth_id9 },
            { id: update_brimunder, cap_id: cap_data_id10, cloth_id: cloth_id10 },
            { id: update_crossband, cap_id: cap_data_id13, cloth_id: cloth_id13 },
          ],
        };
        r_updatte.manufactured_cap_data?.push(...result);
        r_updatte.manufactured_cap_data = r_updatte.manufactured_cap_data?.filter(
          (item) => Object.keys(item).length !== 0,
        );
        const formattedData = {
          ...r_updatte,
          manufactured_cap_data: r_updatte.manufactured_cap_data.map((item) => {
            const { id, ...rest } = item;
            if (id !== null) {
              return item;
            } else {
              return rest;
            }
          }),
        };
        const filteredData = formattedData.manufactured_cap_data.filter((item) => {
          return (
            item.cap_id !== null &&
            item.cloth_id !== null &&
            item.id === undefined &&
            item.cloth_id !== undefined &&
            item.cap_id !== undefined
          );
        });
        const filteredManufacturedCapData = formattedData.manufactured_cap_data.filter(
          (item) => {
            return (
              item.id !== undefined &&
              (item.cap_id !== null || item.cloth_id !== null)
            );
          },
        );
        const newData = {
          ...formattedData,
          manufactured_cap_data: filteredManufacturedCapData,
        };
        newData.manufactured_cap_data.push(...filteredData);
        updateManufacture_cap(newData);
      } else if (a === "UMPIRE HAT") {
        const r_updatte = {
          id: topid,
          cap_type: a,
          manufacture_quantity: q_tity,
          manufactured_cap_data: [
            { id: update_fronttype, cap_id: cap_data_id1, cloth_id: cloth_id1 },
            { id: update_top, cap_id: cap_data_id4, cloth_id: cloth_id4 },
            { id: update_brimtop, cap_id: cap_data_id9, cloth_id: cloth_id9 },
            { id: update_brimunder, cap_id: cap_data_id10, cloth_id: cloth_id10 },
          ],
        };
        r_updatte.manufactured_cap_data?.push(...result);
        r_updatte.manufactured_cap_data = r_updatte.manufactured_cap_data?.filter(
          (item) => Object.keys(item).length !== 0,
        );
        const formattedData = {
          ...r_updatte,
          manufactured_cap_data: r_updatte.manufactured_cap_data.map((item) => {
            const { id, ...rest } = item;
            if (id !== null) {
              return item;
            } else {
              return rest;
            }
          }),
        };
        const filteredData = formattedData.manufactured_cap_data.filter((item) => {
          return (
            item.cap_id !== null &&
            item.cloth_id !== null &&
            item.id === undefined &&
            item.cloth_id !== undefined &&
            item.cap_id !== undefined
          );
        });
        const filteredManufacturedCapData = formattedData.manufactured_cap_data.filter(
          (item) => {
            return (
              item.id !== undefined &&
              (item.cap_id !== null || item.cloth_id !== null)
            );
          },
        );
        const newData = {
          ...formattedData,
          manufactured_cap_data: filteredManufacturedCapData,
        };
        newData.manufactured_cap_data.push(...filteredData);
        updateManufacture_cap(newData);
      } else {
        const r_updatte = {
          id: topid,
          cap_type: a,
          manufacture_quantity: q_tity,
          manufactured_cap_data: [
            { id: update_fronttype, cap_id: cap_data_id1, cloth_id: cloth_id1 },
            { id: update_backtype, cap_id: cap_data_id2, cloth_id: cloth_id2 },
            { id: update_middle, cap_id: cap_data_id3, cloth_id: cloth_id3 },
            { id: update_top, cap_id: cap_data_id4, cloth_id: cloth_id4 },
            { id: update_under, cap_id: cap_data_id5, cloth_id: cloth_id5 },
          ],
        };
        r_updatte.manufactured_cap_data?.push(...result);
        r_updatte.manufactured_cap_data = r_updatte.manufactured_cap_data?.filter(
          (item) => Object.keys(item).length !== 0,
        );
        const formattedData = {
          ...r_updatte,
          manufactured_cap_data: r_updatte.manufactured_cap_data.map((item) => {
            const { id, ...rest } = item;
            if (id !== null) {
              return item;
            } else {
              return rest;
            }
          }),
        };
        const filteredData = formattedData.manufactured_cap_data.filter((item) => {
          return (
            item.cap_id !== null &&
            item.cloth_id !== null &&
            item.id === undefined &&
            item.cloth_id !== undefined &&
            item.cap_id !== undefined
          );
        });
        const filteredManufacturedCapData = formattedData.manufactured_cap_data.filter(
          (item) => {
            return (
              item.id !== undefined &&
              (item.cap_id !== null || item.cloth_id !== null)
            );
          },
        );
        const newData = {
          ...formattedData,
          manufactured_cap_data: filteredManufacturedCapData,
        };
        newData.manufactured_cap_data.push(...filteredData);
        updateManufacture_cap(newData);
      }
    }
  };

  useEffect(() => {
    console.log("dummys", creatCapResponseInfo)
    if (creatCapResponseInfo.data) {
      console.log(creatCapResponseInfo.data.data.id);
      formval.manufacture_cap = creatCapResponseInfo.data.data.id;
      console.log(formval);
    }
    if (creatCapResponseInfo.status === "fulfilled") {
      createJobcard(formval);
    }
    if (creatCapResponseInfo.status === "rejected") {
      console.log(creatCapResponseInfo?.error?.data?.message)
      message.error(creatCapResponseInfo?.error?.data?.message);
    }
  }, [creatCapResponseInfo]);

  // console.log(formValues?.manufacture_cap);

  // if(formValues&&formValues?.manufacture_cap){
  //   fetchManufacture_cap(formValues?.manufacture_cap)

  // }

  // useEffect(() => {
  // if(fetchResponseInfo){
  //   console.log("efect")
  //   console.log(fetchResponseInfo)
  // }
  // }, [fetchResponseInfo]);

  const getFabric1 = (data) => {
    setFrontColor("pending");
    console.log("hellos")
    // dispatch(fetchColor(data));
    // console.log(colorx.users.filter((item)=>item.cap_data!==null&&item.cap_data?.quantity!==0).map((c)=>c.color))
    // console.log(colorx.users)

    console.log(a);
    // console.log(colorx.users.filter((items)=>items.cap_data))
    //FOR SELECTING ACCORDING TO ITS CAP TYPE
    console.log(
      colors
        .filter(
          (items) =>
            items.cap_data &&
            items.cap_data?.cap_type === a &&
            items.cloth_type === data
        )
        .map((c) => c.color)
    );

    // options={colorx.users.filter((item)=>item.cap_data!==null&&item.cap_data?.quantity!==0).map((c)=>c.color)}
    // options={colorx.users.map((colorx) => colorx.color)}
    setFronttype(data);
  };
  // console.log(filter(colorx.users.map((colorx) => colorx.color&&colorx.cap_data!==null)))
  // console.log(colors)
  const [quantity1, setquantity1] = useState();
  const [quantity2, setquantity2] = useState();
  const [quantity3, setquantity3] = useState();
  const [quantity4, setquantity4] = useState();
  const [quantity5, setquantity5] = useState();
  const [quantity6, setquantity6] = useState();
  const [quantity9, setquantity9] = useState();
  const [quantity10, setquantity10] = useState();
  const [quantity13, setquantity13] = useState();
  const getColor1 = (data) => {
    setFrontColor(data);

    const x = colors?.filter(
      (item) => item.cloth_type === fronttype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === fronttype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f1
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f1
        )
      )
      .map((cap) => cap.id);
    if (filteredIds[0] !== undefined) {

      setCap_data_id1(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id1(null)
    }
    try {
      setcloth_id1(
        x.filter(
          (item) => item.cloth_type === fronttype && item.color === data
        )[0].id
      );

      setquantity1(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === fronttype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f1
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f1
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity1("null");
    }
    console.log(
      "cap_id :", filteredIds[0],
      "cloth_id :", x.filter(
        (item) => item?.cloth_type === fronttype && item?.color === data
      )[0]?.id)
  };









  const hello = (data) => {

    console.log(data)
  }















  const getFabric2 = (data) => {
    setbackColor("pending");
    // dispatch(fetchColor(data));
    setbacktype(data);
  };
  const getColor2 = (data) => {
    setbackColor(data);

    const x = colors?.filter(
      (item) => item.cloth_type === backtype && item.color === data
    );

    // setCap_data_id2(
    //   x.filter(
    //     (item) =>
    //     item.cloth_type === backtype &&
    //     item.color === data &&
    //     item.cap_data?.cap_type === a &&
    //     item.cap_data?.cap_side_type === f2
    //     )[0].cap_data?.id
    //     );

    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === backtype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f2
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f2
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {

      setCap_data_id2(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id2(null)
    }

    try {
      setcloth_id2(
        x.filter(
          (item) => item.cloth_type === backtype && item.color === data
        )[0].id
      );
      setquantity2(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === backtype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f2
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f2
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity2("null");
    }
  };
  const getFabric3 = (data) => {
    setmiddleColor("pending");
    // dispatch(fetchColor(data));
    setmiddletype(data);
  };
  const getColor3 = (data) => {
    setmiddleColor(data);

    const x = colors?.filter(
      (item) => item.cloth_type === middletype && item.color === data
    );

    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === middletype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f3
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f3
        )
      )
      .map((cap) => cap.id);
    if (filteredIds[0] !== undefined) {

      setCap_data_id3(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id3(null)
    }
    setCap_data_id3(filteredIds[0]);

    try {
      setcloth_id3(
        x.filter(
          (item) => item.cloth_type === middletype && item.color === data
        )[0].id
      );
      setquantity3(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === middletype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f3
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f3
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity3("null");
    }
  };
  const getFabric4 = (data) => {
    settopColor("pending");
    // dispatch(fetchColor(data));
    settoptype(data);
  };
  const getColor4 = (data) => {
    settopColor(data);

    const x = colors?.filter(
      (item) => item.cloth_type === toptype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === toptype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f4
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f4
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {

      setCap_data_id4(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id4(null)
    }

    try {
      setcloth_id4(
        x.filter(
          (item) => item.cloth_type === toptype && item.color === data
        )[0].id
      );
      setquantity4(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === toptype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f4
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f4
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity4("null");
    }
  };
  const getFabric5 = (data) => {
    setunderColor("pending");
    // dispatch(fetchColor(data));
    setundertype(data);
  };
  const getColor5 = (data) => {
    setunderColor(data);

    const x = colors?.filter(
      (item) => item.cloth_type === undertype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === undertype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f5
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f5
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {

      setCap_data_id5(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id5(null)
    }

    try {
      setcloth_id5(
        x.filter(
          (item) => item.cloth_type === undertype && item.color === data
        )[0].id
      );
      setquantity5(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === undertype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f5
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f5
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity5("null");
    }
  };
  const getFabric6 = (data) => {
    setpipingColor("pending");
    // dispatch(fetchColor(data));

    setpipingtype(data);
  };
  const getColor6 = (value) => {
    setpipingColor(value);


    const filteredItems = colors?.filter(
      (item) => item.type === pipingtype && item.color === value
    );

    // Extract the id and cap_data?.id values from the filtered items
    const result = filteredItems.map((item) => ({
      cloth_id: item.id,
      cap_id: item.cap_data[0].id,
    }));

    console.log(result);
    if (formValues) {
      console.log();
      function findCapMaterialWithVisorType(data) {
        for (const item of data.manufacturedcapdata_set) {
          const capMaterial = item.cap_material;
          if (capMaterial && capMaterial.cap_material === "PIPING") {
            return item.id;
          }
        }
        return null; // Return null if no cap material with visor type found
      }

      const visorTypeId = findCapMaterialWithVisorType(
        manufacture_capdata
      );
      console.log("Visor Type ID:", visorTypeId);

      if (visorTypeId) {
        result[0].id = visorTypeId;
      }
    }
    console.log(result[0]);
    setFor_piping(result[0]);

    // console.log(formx)
  };

  // Cross Band Handler for Bucket Hat
  const getFabric13 = (data) => {
    setCrossBandColor("pending");
    setCrossBandtype(data);
  };

  const getColor13 = (data) => {
    setCrossBandColor(data);
    form.setFieldsValue({ main_fabric_Cross_Band_color: data });
    const x = colors?.filter(
      (item) => item.cloth_type === crossbandtype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === crossbandtype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f13
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f13
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {
      setCap_data_id13(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id13(null);
    }

    try {
      setcloth_id13(
        x.filter(
          (item) => item.cloth_type === crossbandtype && item.color === data
        )[0].id
      );
      setquantity13(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === crossbandtype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f13
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f13
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity13("null");
    }
  };

  const getFabric9 = (data) => {
    setBrimTopColor("pending");
    setBrimToptype(data);
  };

  const getColor9 = (data) => {
    setBrimTopColor(data);
    form.setFieldsValue({ main_fabric_Brim_Top_color: data });
    const x = colors?.filter(
      (item) => item.cloth_type === brimtoptype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === brimtoptype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f9
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f9
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {
      setCap_data_id9(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id9(null);
    }

    try {
      setcloth_id9(
        x.filter(
          (item) => item.cloth_type === brimtoptype && item.color === data
        )[0].id
      );
      setquantity9(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === brimtoptype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f9
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f9
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity9("null");
    }
  };

  const getFabric10 = (data) => {
    setBrimUnderColor("pending");
    setBrimUndertype(data);
  };

  const getColor10 = (data) => {
    setBrimUnderColor(data);
    form.setFieldsValue({ main_fabric_Brim_Under_color: data });
    const x = colors?.filter(
      (item) => item.cloth_type === brimundertype && item.color === data
    );
    const filteredIds = colors
      ?.filter(
        (item) =>
          item.cloth_type === brimundertype &&
          item.color === data &&
          item.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === f10
          )
      )
      .flatMap((item) =>
        item.cap_data?.filter(
          (cap) => cap.cap_type === a && cap.cap_side_type === f10
        )
      )
      .map((cap) => cap.id);

    if (filteredIds[0] !== undefined) {
      setCap_data_id10(filteredIds[0]);
    }
    if (filteredIds[0] === undefined) {
      setCap_data_id10(null);
    }

    try {
      setcloth_id10(
        x.filter(
          (item) => item.cloth_type === brimundertype && item.color === data
        )[0].id
      );
      setquantity10(
        colors
          ?.filter(
            (item) =>
              item.cloth_type === brimundertype &&
              item.color === data &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && cap.cap_side_type === f10
              )
          )
          .flatMap((item) =>
            item.cap_data?.filter(
              (cap) => cap.cap_type === a && cap.cap_side_type === f10
            )
          )
          .map((cap) => cap.quantity)
      );
    } catch (e) {
      setquantity10("null");
    }
  };

  // console.log(formValues)

  const getUpadtedcolor = () => {
    if (formValues == undefined) {
    } else {
      setFrontColor(formValues?.main_fabric_Front_color);
      setbackColor(formValues?.main_fabric_Back_color);
      setmiddleColor(formValues?.main_fabric_Middle_color);
      settopColor(formValues?.main_fabric_Top_color);
      setunderColor(formValues?.main_fabric_Under_color);
      setpipingColor(formValues?.piping_color);
      setBrimTopColor(formValues?.main_fabric_Brim_Top_color);
      setBrimUnderColor(formValues?.main_fabric_Brim_Under_color);
      // setpipingColor(formValues?.piping_color);
    }
  };





  const button = "CAP BUTTON"

  const [button_obj, setButton_obj] = useState();
  const getbutton = (data) => {
    function findCapIdAndClothId(capMaterial, capType) {
      let result = null;

      // Loop through the data array to find the matching entry
      for (const entry of colors) {
        if (entry.cap_material === capMaterial) {
          // Loop through the cap_data array of the current entry to find the matching cap_type
          for (const capData of entry.cap_data) {
            if (capData.cap_type === capType) {
              result = {
                cap_id: capData.id,
                cloth_id: capData.color_cloth
              };
              break;
            }
          }
          // If we found the matching cap_data, break out of the outer loop as well
          if (result !== null) {
            break;
          }
        }
      }

      return result;
    }


    const result = findCapIdAndClothId(data, a);
    console.log(result)
    setButton_obj(result)

  }


























  const [visior, setvisior] = useState();
  const [fusing, setfusing] = useState();
  const [taper_obj, settaper_obj] = useState();
  const [sweat_bands, setsweat_bands] = useState();
  const [full_closer_obj, setFull_closer_obj] = useState();
  const [elastic_obj, setElastic_obj] = useState();
  const visor_type = "visor_type";
  const BINDER = "BINDER";
  const STRIP = "SIZING STRIP";
  const fusing_type = "FUSING";
  const foam_type = "FOAM";
  const brim_foam_init = "BRIM FOAM";
  const o_ring_init = "O-RING";
  const snap_pack_init = "SNAPACK";
  const sweat_band_holding_init = "SWEAT BAND HOLDING";

  const nonon_type = "NONON";
  const taper = "TAPER";
  const sweatsss = "sweat_type";
  const full_closer_init = "FULL CLOSURE ELASTIC";
  const elastic_init = "ELASTIC";
  const interlining_init = "INTERLINING";
  const buckel_init = "BUCKLE"
  const carton_init = "CARTON"
  const plastic_init = "PLASTIC BAG"
  const buckle_belt_init = "BUCKLE BELT"
  const [appen, setAppen] = useState([]);

  const [binder_obj, setBinder_obj] = useState();
  const [brim_foam_obj, setBrim_foam_obj] = useState();
  const [strip_obj, setStrip_obj] = useState();
  const [foam, setFoam] = useState();
  const [nonon, setNonon] = useState();
  const [carton_obj, setCarton_obj] = useState();
  const [plastic_obj, setPlastic_obj] = useState();

  async function urlToFile(url, filename) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error(`Error fetching image from ${url}:`, error);
      return null;
    }
  }

  const fun_for_type = (type, data) => {
    try {



      if (formValues) {
        if (type === "CARTON" || type === "PLASTIC BAG") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === type) {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);

          // foam extraction login
          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.type === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.type === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));
          if (visorTypeId !== null) {
            results[0].id = visorTypeId;
            console.log("new foam result", results);
          }

          if (type === "CARTON") {
            setCap_M();
            console.log("alpha", results[0]);
            setCarton_obj(results[0]);
          }
          if (type === "PLASTIC BAG") {
            setCap_M();
            console.log("alpha", results[0]);
            setPlastic_obj(results[0]);
          }

        }
      } else {
        if (type === "CARTON" || type === "PLASTIC BAG") {

          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.type === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.type === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));

          console.log("off", results);

          if (type === "CARTON") {
            setCap_M();
            console.log("alpha", results[0]);
            setCarton_obj(results[0]);
          }
          if (type === "PLASTIC BAG") {
            setCap_M();
            console.log("alpha", results[0]);
            setPlastic_obj(results[0]);
          }
        }
      }
    } catch (error) {
      console.log("error", error)
    }
  }


  const objfun = (type, data) => {

    try {


      if (formValues) {
        console.log("inif");
        console.log(type);
        if (type === "BUCKLE") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === type) {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);
          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.type === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.type === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));
          if (visorTypeId !== null) {
            results[0].id = visorTypeId;
            console.log("new foam result", results);
          }
          if (type === "BUCKLE") {

            setBulkle_obj(results[0]);
            console.log("alpha", results[0]);
          }
        }

        if (type === snap_pack_init || type === "BUTTON" || type === o_ring_init || type === sweat_band_holding_init || type === "BUCKLE BELT" || type === "FOAM" || type === "NONON" || type === "BINDER" || type === "SIZING STRIP" || type === "INTERLINING" || type === "ELASTIC" || type === "FULL CLOSURE ELASTIC" || type === "BRIM FOAM") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === type) {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);

          // foam extraction login
          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.color === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.color === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));
          if (visorTypeId !== null) {
            results[0].id = visorTypeId;
            console.log("new foam result", results);
          }

          if (type === "BUTTON") {
            setButton_color_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === o_ring_init) {
            setO_ring_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === snap_pack_init) {
            setsnappack_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === sweat_band_holding_init) {
            setSweat_band_holding_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "BUCKLE BELT") {
            setBulkle_belt_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "FOAM") {
            setFoam(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "NONON") {
            setNonon(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "BINDER") {
            setBinder_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "SIZING STRIP") {
            setStrip_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "ELASTIC") {
            setInterLINING(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "FULL CLOSURE ELASTIC") {
            setFull_closer_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "INTERLINING") {
            setElastic_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "BRIM FOAM") {
            setBrim_foam_obj(results[0]);
            console.log("alpha", results[0]);
          }

        }

        if (type === "visor_type") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === "VISOR TYPE") {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);

          const separatedParts = data.split(":");

          const beforeColon = separatedParts[0].trim();
          const afterColon = separatedParts[1].trim();

          const desiredItems = colors?.filter(
            (item) =>
              item.type === beforeColon &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && item.color === afterColon
              )
          );

          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter((cap) => cap.cap_type === a && item.color === afterColon)
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });

          if (visorTypeId !== null) {
            result[0].id = visorTypeId;
          }
          console.log(result[0]);

          setvisior(result[0]);
        }

        if (type === "FUSING" || type === "TAPER") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === type) {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);

          console.log();
          // Separate "fusing 67" and "quantity = 12"
          const parts = data.split(" : ");

          // Extract quantity value
          const quantityPart = parts[1].split(" = ");
          const quantityCount = quantityPart[1];

          console.log(parts[0]);
          if (parts[0] === "null") {
            parts[0] = null;
          }
          console.log(quantityCount);
          const desiredItems = colors?.filter(
            (item) =>
              item.type === parts[0] &&
              item.color === quantityCount &&
              item.cap_material === type &&
              item.cap_data?.some((cap) => cap.cap_type === a)
          );
          console.log(desiredItems);
          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter(
                (cap) =>
                  cap.cap_type === a &&
                  // cap.quantity === parseFloat(quantityCount)
                  item.color === quantityCount
              )
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });

          if (visorTypeId !== null) {
            result[0].id = visorTypeId;
          }

          console.log(result[0]);
          if (type === "FUSING") {
            console.log("selected", result[0])
            setfusing(result[0]);
          }
          if (type === "TAPER") {
            settaper_obj(result[0])
          }
        }

        if (type === "sweat_type") {
          function findCapMaterialWithVisorType(data) {
            for (const item of data.manufacturedcapdata_set) {
              const capMaterial = item.cap_material;
              if (capMaterial && capMaterial.cap_material === "SWEATE BAND") {
                return item.id;
              }
            }
            return null; // Return null if no cap material with visor type found
          }

          const visorTypeId = findCapMaterialWithVisorType(
            manufacture_capdata
          );
          console.log("Visor Type ID:", visorTypeId);

          const parts = data.split(" : ");

          // Extract quantity value
          const quantityPart = parts[1].split(" = ");
          const quantityCount = quantityPart[1];

          console.log(parts[0]);
          console.log(quantityCount);
          console.log(a);

          const desiredItems = colors?.filter(
            (item) =>
              item.type === parts[0] &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && item.color === quantityCount
              )
          );

          console.log(desiredItems);
          console.log(
            colors?.filter(
              (item) =>
                item.type === parts[0] &&
                item.cap_data?.filter(
                  (cap) => cap.cap_type === a && item.color === quantityCount
                )
            )
          );
          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter((cap) => cap.cap_type === a && item.color === quantityCount)
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });

          if (visorTypeId !== null) {
            result[0].id = visorTypeId;
          }

          setsweat_bands(result[0]);
        }
      } else {

        if (type === "BUCKLE") {
          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.type === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.type === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));
          if (type === "BUCKLE") {
            setCap_M();

            setBulkle_obj(results[0]);
            console.log("alpha", results[0]);
          }
        }


        //ONLY FOR COLOR SELECTION
        if (type === "SNAPACK" || type === "BUTTON" || type === "O-RING" || type === sweat_band_holding_init || type === "BUCKLE BELT" || type === "FOAM" || type === "NONON" || type === "BINDER" || type === "SIZING STRIP" || type === "INTERLINING" || type === "ELASTIC" || type === "FULL CLOSURE ELASTIC" || type === "BRIM FOAM") {


          const filteredItems = colors?.filter(
            (item) =>
              item.cap_data &&
              item.cap_data?.some(
                (capData) =>
                  item.color === data &&
                  capData.cap_type === a &&
                  item.cap_material === type

              )
          );

          const results = filteredItems.map((item) => ({
            cloth_id: item.id,
            cap_id: item.cap_data?.find(
              (capData) =>
                item.color === data &&
                capData.cap_type === a &&
                item.cap_material === type

            ).id,
          }));

          console.log("off", results);

          if (type === "BUTTON") {
            setCap_M();
            console.log("alpha", results[0]);
            setButton_color_obj(results[0]);
          }
          if (type === sweat_band_holding_init) {
            setCap_M();
            console.log("alpha", results[0]);
            setSweat_band_holding_obj(results[0]);
          }

          if (type === "O-RING") {
            setCap_M();
            console.log("alpha", results[0]);
            setO_ring_obj(results[0]);
          }
          if (type === "SNAPACK") {
            setCap_M();
            console.log("alpha", results[0]);
            setsnappack_obj(results[0]);
          }
          if (type === "BUCKLE BELT") {
            setCap_M();
            console.log("alpha", results[0]);
            setBulkle_belt_obj(results[0]);
          }

          if (type === "FOAM") {
            setCap_M();
            console.log("alpha", results[0]);
            setFoam(results[0]);
          }
          if (type === "NONON") {
            setCap_M();
            console.log("alpha", results[0]);
            setNonon(results[0]);
          }
          if (type === "BINDER") {
            setCap_M();

            setBinder_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "SIZING STRIP") {
            setCap_M();

            setStrip_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "ELASTIC") {
            setCap_M();

            setInterLINING(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "FULL CLOSURE ELASTIC") {
            setCap_M();

            setFull_closer_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "INTERLINING") {
            setCap_M();

            setElastic_obj(results[0]);
            console.log("alpha", results[0]);
          }
          if (type === "BRIM FOAM") {
            setCap_M();

            setBrim_foam_obj(results[0]);
            console.log("alpha", results[0]);
          }

        }

        if (type === "visor_type") {
          const separatedParts = data.split(":");

          const beforeColon = separatedParts[0].trim();
          const afterColon = separatedParts[1].trim();

          const desiredItems = colors?.filter(
            (item) =>
              item.type === beforeColon &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && item.color === afterColon
              )
          );

          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter((cap) => cap.cap_type === a && item.color === afterColon)
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });

          console.log(result[0]);
          setvisior(result[0]);
        }

        if (type === "FUSING" || type === "TAPER") {

          // Separate "fusing 67" and "quantity = 12"
          const parts = data.split(" : ");
          // Extract quantity value
          if (parts[0] === "null") {
            console.log("tiger", parts[0])
            parts[0] = null;
            console.log("tiger", parts[0])
          }

          const quantityPart = parts[1].split(" = ");
          const quantityCount = quantityPart[1];

          // console.log(parts[0]);
          console.log(quantityCount);

          const desiredItems = colors?.filter(
            (item) =>
              item.type === parts[0] &&
              item.color === quantityCount &&
              item.cap_material === type &&
              item.cap_data?.some((cap) => cap.cap_type === a)
          );

          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter(
                (cap) =>
                  cap.cap_type === a &&
                  // cap.quantity === parseFloat(quantityCount)
                  item.color === quantityCount
              )
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });
          if (type === "FUSING") {
            console.log("selectedd", result[0])
            setfusing(result[0]);
          }
          if (type === "TAPER") {
            settaper_obj(result[0])
          }
        }

        if (type === "sweat_type") {
          const parts = data.split(" : ");

          // Extract quantity value
          const quantityPart = parts[1].split(" = ");
          const quantityCount = quantityPart[1];

          const desiredItems = colors?.filter(
            (item) =>
              item.type === parts[0] &&
              item.cap_data?.some(
                (cap) => cap.cap_type === a && item.color === quantityCount
              )
          );

          const result = desiredItems.map((item) => {
            const { id, cap_data } = item;
            const matchingCapDataIds = cap_data
              .filter((cap) => cap.cap_type === a && item.color === quantityCount)
              .map((cap) => cap.id);

            return { cloth_id: id, cap_id: matchingCapDataIds[0] };
          });

          setsweat_bands(result[0]);
        }
        // console.log(visior)

        console.log(data);
        // setMat(arr=>[...arr,])
      }



    } catch (error) {
      console.log("error", type, data)

    }
  };

  // colors
  const [frontcolor, setFrontColor] = useState(null);
  const [backcolor, setbackColor] = useState(null);
  const [middlecolor, setmiddleColor] = useState(null);
  const [topcolor, settopColor] = useState(null);
  const [undercolor, setunderColor] = useState(null);
  const [pipingcolor, setpipingColor] = useState(null);
  const [brimtopcolor, setBrimTopColor] = useState(null);
  const [brimundercolor, setBrimUnderColor] = useState(null);
  const [crossbandcolor, setCrossBandColor] = useState(null);
  // fabric type


  useEffect(() => {
    if (formValues) {
      setFronttype(formValues?.main_fabric_Front_type)
      setbacktype(formValues?.main_fabric_Back_type)
      setmiddletype(formValues?.main_fabric_Middle_type)
      settoptype(formValues?.main_fabric_Top_type)
      setundertype(formValues?.main_fabric_Under_type)
      setpipingtype(formValues?.piping_type)
      setBrimToptype(formValues?.main_fabric_Brim_Top_type)
      setBrimUndertype(formValues?.main_fabric_Brim_Under_type)
      // setBack_closer(formValues?.back_close_type)
      setBack_closer_colors(() => {
        const list = colors
          ?.filter((item) => item?.type === formValues?.back_close_type)
          .filter((it) => it.cap_data?.some((op) => op.cap_type === a)) || [];
        const seen = new Set();
        const opts = [];
        for (const it of list) {
          const label = it?.color;
          if (!label) continue;
          const key = String(label).trim().toLowerCase();
          if (seen.has(key)) continue;
          seen.add(key);
          opts.push({ label, value: label, color_code: it?.color_code });
        }
        return opts;
      });
    }
  }, [formValues]);



  const [fronttype, setFronttype] = useState(null);
  const [backtype, setbacktype] = useState(null);
  const [middletype, setmiddletype] = useState(null);
  const [toptype, settoptype] = useState(null);
  const [undertype, setundertype] = useState(null);
  const [pipingtype, setpipingtype] = useState(null);
  const [brimtoptype, setBrimToptype] = useState(null);
  const [brimundertype, setBrimUndertype] = useState(null);
  const [crossbandtype, setCrossBandtype] = useState(null);

  // Inventory-backed Piping color options for selected piping type
  const { data: pipingInventory } = useFetchInventoryQuery({
    type: "CAP MATERIAL",
    cap_material: "PIPING",
    sub_type: pipingtype || undefined,
    page_size: 1000,
  });
  const piping_color_options = useMemo(() => {
    const inv = Array.isArray(pipingInventory)
      ? pipingInventory
      : pipingInventory?.results || [];
    // Aggregate qty per color, keep a representative color_code if present
    const byColor = new Map();
    for (const row of inv) {
      const color = row?.color_cloth?.color;
      const color_code = row?.color_cloth?.color_code || null;
      const qtyVal = row?.quantity;
      if (!color) continue;
      const key = String(color).trim().toLowerCase();
      const prev = byColor.get(key) || { label: color, value: color, qty: 0, color_code };
      const num = typeof qtyVal === 'number' ? qtyVal : parseFloat(qtyVal);
      prev.qty = (prev.qty || 0) + (isNaN(num) ? 0 : num);
      if (!prev.color_code && color_code) prev.color_code = color_code;
      byColor.set(key, prev);
    }
    // Include colors from existing list (from colors dataset) so dropdown isn't empty
    const list = colors
      ?.filter((item) => item?.type === pipingtype && item.cap_material === f6)
      ?.filter((it) => it.cap_data?.some((op) => op.cap_type === a)) || [];
    for (const it of list) {
      const color = it?.color;
      if (!color) continue;
      const key = String(color).trim().toLowerCase();
      if (!byColor.has(key)) {
        byColor.set(key, { label: color, value: color, color_code: it?.color_code });
      }
    }
    return Array.from(byColor.values());
  }, [pipingInventory, colors, pipingtype, a]);

  // ===== Cloth inventory (available qty) for selected Main Fabric type + color =====
  // This is intentionally separate from the existing cap-type-based fetch logic.
  const shouldFetchClothQty = (clothType, color) =>
    Boolean(clothType) && Boolean(color) && color !== "pending";
  const shouldFetchClothQtyList = (clothType) => Boolean(clothType);

  const { data: invFront } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: fronttype,
      color: frontcolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(fronttype, frontcolor) },
  );
  const { data: invBack } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: backtype,
      color: backcolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(backtype, backcolor) },
  );
  const { data: invMiddle } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: middletype,
      color: middlecolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(middletype, middlecolor) },
  );
  const { data: invTop } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: toptype,
      color: topcolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(toptype, topcolor) },
  );
  const { data: invUnder } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: undertype,
      color: undercolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(undertype, undercolor) },
  );

  // Fetch all inventory rows for the selected fabric type so the color dropdown can show qty per color.
  const { data: invFrontAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: fronttype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(fronttype) },
  );
  const { data: invBackAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: backtype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(backtype) },
  );
  const { data: invMiddleAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: middletype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(middletype) },
  );
  // capButtonOptions defined later, after fetching invCapButtonList

  // Global color list for Button Color (reference only)
  // Include color_code so SelectType can render color flags like main fabric
  const { data: filterOptions } = useFetchInventoryFilterOptionsQuery({});
  const buttonColorOptions = useMemo(() => {
    // Prefer full color objects (with color + color_code) used by eyelet dropdowns
    const source = Array.isArray(colors) ? colors : [];
    if (source.length > 0) {
      const seen = new Map();
      for (const it of source) {
        const name = extractColorName(it?.color ?? '');
        const key = String(name || '').trim().toLowerCase();
        if (!key) continue;
        if (!seen.has(key)) {
          // Keep original color string as label/value; include color_code for flag rendering
          seen.set(key, { label: it.color, value: it.color, color_code: it.color_code });
        }
      }
      return Array.from(seen.values());
    }

    // Fallback: use filter options arrays if colors are not available
    const colorsArr = Array.isArray(filterOptions?.colors) ? filterOptions.colors : [];
    const codesArr = Array.isArray(filterOptions?.color_codes) ? filterOptions.color_codes : [];
    const options = colorsArr.map((c, idx) => ({ label: c, value: c, color_code: codesArr[idx] }))
      .filter((opt) => opt.label !== null && opt.label !== undefined && String(opt.label).trim() !== "");
    const seen = new Set();
    const deduped = [];
    for (const opt of options) {
      const key = String(opt.label).trim().toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        deduped.push(opt);
      }
    }
    return deduped;
  }, [colors, filterOptions]);
  const { data: invTopAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: toptype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(toptype) },
  );
  const { data: invUnderAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: undertype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(undertype) },
  );

  // Cross Band inventory queries
  const { data: invCrossBand } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: crossbandtype,
      color: crossbandcolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(crossbandtype, crossbandcolor) },
  );
  const { data: invCrossBandAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: crossbandtype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(crossbandtype) },
  );

  // Brim Top inventory queries
  const { data: invBrimTop } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: brimtoptype,
      color: brimtopcolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(brimtoptype, brimtopcolor) },
  );
  const { data: invBrimTopAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: brimtoptype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(brimtoptype) },
  );

  // Brim Under inventory queries
  const { data: invBrimUnder } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1,
      cloth_type: brimundertype,
      color: brimundercolor,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQty(brimundertype, brimundercolor) },
  );
  const { data: invBrimUnderAll } = useFetchInventoryQuery(
    {
      page: 1,
      page_size: 1000,
      cloth_type: brimundertype,
      type: "CLOTH MATERIAL",
    },
    { skip: !shouldFetchClothQtyList(brimundertype) },
  );

  // CAP BUTTON inventory list (CAP MATERIAL) to drive dropdown options
  const { data: invCapButtonList } = useFetchInventoryQuery(
    {
      cap_material: 'CAP BUTTON',
      type: 'CAP MATERIAL',
      no_pagination: 'true',
    }
  );
  const capButtonOptions = useMemo(() => {
    const items = Array.isArray(invCapButtonList)
      ? invCapButtonList
      : invCapButtonList?.results || [];
    // Aggregate quantity by CAP BUTTON subtype (or default to 'CAP BUTTON')
    const grouped = items.reduce((acc, it) => {
      const typeLabel = it?.color_cloth?.type || 'CAP BUTTON';
      const qtyRaw = it?.quantity;
      const qty = typeof qtyRaw === 'number' ? qtyRaw : parseFloat(qtyRaw || 0);
      acc[typeLabel] = (acc[typeLabel] || 0) + (isNaN(qty) ? 0 : qty);
      return acc;
    }, {});
    return Object.entries(grouped).map(([label, qty]) => ({ label, value: label, qty }));
  }, [invCapButtonList]);


  const getInvQty = (inv) => inv?.results?.[0]?.quantity ?? inv?.[0]?.quantity ?? null;
  const availableQtyFront = getInvQty(invFront);
  const availableQtyBack = getInvQty(invBack);
  const availableQtyMiddle = getInvQty(invMiddle);
  const availableQtyTop = getInvQty(invTop);
  const availableQtyUnder = getInvQty(invUnder);
  const availableQtyBrimTop = getInvQty(invBrimTop);
  const availableQtyCrossBand = getInvQty(invCrossBand);
  const availableQtyBrimUnder = getInvQty(invBrimUnder);

  const toNum = (v) => {
    if (v === null || v === undefined) return null;
    if (Array.isArray(v)) return toNum(v[0]);
    const n = typeof v === "number" ? v : parseFloat(v);
    return Number.isFinite(n) ? n : null;
  };
  const calcRemain = (available, used) => {
    const aNum = toNum(available);
    const uNum = toNum(used);
    if (aNum === null || uNum === null) return null;
    return aNum - uNum;
  };
  const displayQty = (v) => {
    if (Array.isArray(v)) return v[0] ?? "-";
    return v ?? "-";
  };
  const remainTextStyle = { fontSize: 11, color: "#6b7280", fontWeight: 400 };
  const outOfStockStyle = { fontSize: 11, color: "#ff0000", fontWeight: 400 };

  // Helper function to render remain text with conditional styling
  const renderRemainText = (remainValue) => {
    const remainNum = toNum(remainValue);
    if (remainNum === null || remainNum === undefined || isNaN(remainNum)) {
      return <span style={remainTextStyle}>Remain : -</span>;
    }
    if (remainNum <= 0) {
      return <span style={outOfStockStyle}>Out of stock</span>;
    }
    // Format to exactly 3 decimal places - toFixed returns a string
    // This ensures we always show exactly 3 decimal places, avoiding floating point precision issues
    const formattedRemain = Number(remainNum).toFixed(3);
    return <span style={remainTextStyle}>Remain : {formattedRemain}</span>;
  };

  function normalizeColorKey(c) {
    return typeof c === "string" ? c.trim().toUpperCase() : "";
  }
  function normalizeTypeKey(t) {
    return typeof t === "string" ? t.trim().toUpperCase() : "";
  }
  function makeInvKey(clothType, color) {
    return `${normalizeTypeKey(clothType)}|${normalizeColorKey(color)}`;
  }
  const getInvRows = (inv) => (Array.isArray(inv) ? inv : (inv?.results || []));
  const buildInvQtyByColor = (inv) => {
    const map = {};
    for (const row of getInvRows(inv)) {
      const rawColor = row?.color_cloth?.color ?? row?.color;
      const key = normalizeColorKey(rawColor);
      if (!key) continue;
      const qty = row?.quantity;
      if (qty !== undefined && qty !== null) map[key] = qty;
    }
    return map;
  };

  const buildInvQtyByTypeColor = (clothType, inv) => {
    const map = {};
    const typeKey = normalizeTypeKey(clothType);
    if (!typeKey) return map;
    for (const row of getInvRows(inv)) {
      const rawColor = row?.color_cloth?.color ?? row?.color;
      const colorKey = normalizeColorKey(rawColor);
      if (!colorKey) continue;
      const qty = row?.quantity;
      if (qty !== undefined && qty !== null) {
        map[makeInvKey(typeKey, colorKey)] = qty;
      }
    }
    return map;
  };

  const invQtyByColorFront = useMemo(() => buildInvQtyByColor(invFrontAll), [invFrontAll]);
  const invQtyByColorBack = useMemo(() => buildInvQtyByColor(invBackAll), [invBackAll]);
  const invQtyByColorMiddle = useMemo(() => buildInvQtyByColor(invMiddleAll), [invMiddleAll]);
  const invQtyByColorTop = useMemo(() => buildInvQtyByColor(invTopAll), [invTopAll]);
  const invQtyByColorUnder = useMemo(() => buildInvQtyByColor(invUnderAll), [invUnderAll]);
  const invQtyByColorBrimTop = useMemo(() => buildInvQtyByColor(invBrimTopAll), [invBrimTopAll]);
  const invQtyByColorBrimUnder = useMemo(() => buildInvQtyByColor(invBrimUnderAll), [invBrimUnderAll]);
  const invQtyByColorCrossBand = useMemo(() => buildInvQtyByColor(invCrossBandAll), [invCrossBandAll]);
  const invQtyByTypeColor = useMemo(
    () => ({
      ...buildInvQtyByTypeColor(fronttype, invFrontAll),
      ...buildInvQtyByTypeColor(backtype, invBackAll),
      ...buildInvQtyByTypeColor(middletype, invMiddleAll),
      ...buildInvQtyByTypeColor(toptype, invTopAll),
      ...buildInvQtyByTypeColor(undertype, invUnderAll),
      ...buildInvQtyByTypeColor(brimtoptype, invBrimTopAll),
      ...buildInvQtyByTypeColor(crossbandtype, invCrossBandAll),
      ...buildInvQtyByTypeColor(brimundertype, invBrimUnderAll),
    }),
    [
      fronttype,
      invFrontAll,
      backtype,
      invBackAll,
      middletype,
      invMiddleAll,
      toptype,
      invTopAll,
      undertype,
      invUnderAll,
      brimtoptype,
      crossbandtype,
      invCrossBandAll,
      invBrimTopAll,
      brimundertype,
      invBrimUnderAll,
    ],
  );

  const getColorOptionsWithQty = (sideType, clothType, invQtyMap) => {
    if (!clothType || !Array.isArray(colors)) return [];
    const matched = colors
      .filter(
        (item) =>
          item?.cloth_type === clothType &&
          item?.cap_data?.some(
            (cap) => cap.cap_type === a && cap.cap_side_type === sideType,
          ),
      )
      .filter((item) => item?.color);

    // Build a map to de-duplicate by color while retaining color_code
    const byColor = new Map();
    for (const it of matched) {
      const clr = it.color;
      if (!byColor.has(clr)) {
        byColor.set(clr, it.color_code || null);
      }
    }

    return Array.from(byColor.entries()).map(([color, color_code]) => ({
      value: color,
      label: color,
      qty: invQtyMap?.[normalizeColorKey(color)] ?? "-",
      color_code,
    }));
  };

  // Running (frontend-only) consumption per fabric type + color across all selected sides.
  const consumedByTypeColor = useMemo(() => {
    const map = {};
    const jobQty = toNum(q_tity) ?? 0;
    const add = (clothType, color, used) => {
      if (!clothType || !color || color === "pending") return;
      const usedNum = toNum(used);
      if (usedNum === null) return;
      const key = makeInvKey(clothType, color);
      map[key] = (map[key] || 0) + usedNum * jobQty;
    };
    add(fronttype, frontcolor, quantity1);
    add(backtype, backcolor, quantity2);
    add(middletype, middlecolor, quantity3);
    add(toptype, topcolor, quantity4);
    add(undertype, undercolor, quantity5);
    add(brimtoptype, brimtopcolor, quantity9);
    add(crossbandtype, crossbandcolor, quantity13);
    add(brimundertype, brimundercolor, quantity10);
    return map;
  }, [
    q_tity,
    fronttype,
    frontcolor,
    quantity1,
    backtype,
    backcolor,
    quantity2,
    middletype,
    middlecolor,
    quantity3,
    toptype,
    topcolor,
    quantity4,
    undertype,
    undercolor,
    quantity5,
    brimtoptype,
    crossbandtype,
    crossbandcolor,
    quantity13,
    brimtopcolor,
    quantity9,
    brimundertype,
    brimundercolor,
    quantity10,
  ]);

  // Remaining qty is computed AFTER invQtyByTypeColor & consumedByTypeColor are initialized.
  const getBaseInvQtyFor = (clothType, color, sideAvailableQty) => {
    if (!clothType || !color || color === "pending") return null;
    const key = makeInvKey(clothType, color);
    const fromList = invQtyByTypeColor?.[key];
    const base = toNum(fromList ?? sideAvailableQty);
    return base;
  };

  const getRemainFor = (clothType, color, sideAvailableQty) => {
    const base = getBaseInvQtyFor(clothType, color, sideAvailableQty);
    if (base === null) return null;
    const key = makeInvKey(clothType, color);
    const consumed = toNum(consumedByTypeColor?.[key]) ?? 0;
    const remain = base - consumed;
    return remain;
  };

  const remainFront = getRemainFor(fronttype, frontcolor, availableQtyFront);
  const remainBack = getRemainFor(backtype, backcolor, availableQtyBack);
  const remainMiddle = getRemainFor(middletype, middlecolor, availableQtyMiddle);
  const remainTop = getRemainFor(toptype, topcolor, availableQtyTop);
  const remainUnder = getRemainFor(undertype, undercolor, availableQtyUnder);
  const remainBrimTop = getRemainFor(brimtoptype, brimtopcolor, availableQtyBrimTop);
  const remainBrimUnder = getRemainFor(brimundertype, brimundercolor, availableQtyBrimUnder);
  const remainCrossBand = getRemainFor(crossbandtype, crossbandcolor, availableQtyCrossBand);

  // Out of stock modal state
  const [outOfStockModal, setOutOfStockModal] = useState({
    visible: false,
    fabricName: null,
    colorName: null,
    colorValue: null,
  });

  // Use shared util `extractColorName` from utils/identifyColor (imported at top)

  // Track previous color values to detect new color selections
  const prevColorsRef = useRef({
    frontcolor: null,
    backcolor: null,
    middlecolor: null,
    topcolor: null,
    undercolor: null,
    brimtopcolor: null,
    brimundercolor: null,
    crossbandcolor: null,
  });

  // Detect out of stock when a color is newly selected and remain is <= 0
  useEffect(() => {
    const checkOutOfStock = (remain, fabricType, color, prevColor) => {
      // Only check if this is a new color selection (color changed from previous)
      if (color && color !== "pending" && color !== prevColor && fabricType) {
        const remainNum = toNum(remain);
        if (remainNum !== null && remainNum <= 0) {
          setOutOfStockModal({
            visible: true,
            fabricName: fabricType,
            colorName: extractColorName(color),
            colorValue: color,
          });
        }
      }
    };

    // Check each side when color changes
    checkOutOfStock(remainFront, fronttype, frontcolor, prevColorsRef.current.frontcolor);
    checkOutOfStock(remainBack, backtype, backcolor, prevColorsRef.current.backcolor);
    checkOutOfStock(remainMiddle, middletype, middlecolor, prevColorsRef.current.middlecolor);
    checkOutOfStock(remainTop, toptype, topcolor, prevColorsRef.current.topcolor);
    checkOutOfStock(remainUnder, undertype, undercolor, prevColorsRef.current.undercolor);
    // Bucket Hat sides
    checkOutOfStock(remainBrimTop, brimtoptype, brimtopcolor, prevColorsRef.current.brimtopcolor);
    checkOutOfStock(remainBrimUnder, brimundertype, brimundercolor, prevColorsRef.current.brimundercolor);
    checkOutOfStock(remainCrossBand, crossbandtype, crossbandcolor, prevColorsRef.current.crossbandcolor);

    // Update previous colors
    prevColorsRef.current = {
      frontcolor,
      backcolor,
      middlecolor,
      topcolor,
      undercolor,
      brimtopcolor,
      brimundercolor,
      crossbandcolor,
    };
  }, [
    frontcolor, backcolor, middlecolor, topcolor, undercolor,
    remainFront, remainBack, remainMiddle, remainTop, remainUnder,
    fronttype, backtype, middletype, toptype, undertype,
    brimtopcolor, brimundercolor, crossbandcolor,
    remainBrimTop, remainBrimUnder, remainCrossBand,
    brimtoptype, brimundertype, crossbandtype,
  ]);

  //cap_data_id which is cap_data obj id
  const [cap_data_id1, setCap_data_id1] = useState(null);
  const [cap_data_id2, setCap_data_id2] = useState(null);
  const [cap_data_id3, setCap_data_id3] = useState(null);
  const [cap_data_id4, setCap_data_id4] = useState(null);
  const [cap_data_id5, setCap_data_id5] = useState(null);
  const [cap_data_id6, setCap_data_id6] = useState(null);
  const [cap_data_id9, setCap_data_id9] = useState(null);
  const [cap_data_id10, setCap_data_id10] = useState(null);
  const [cap_data_id13, setCap_data_id13] = useState(null);
  //cloth_id whuch is id=1
  const [cloth_id1, setcloth_id1] = useState(null);
  const [cloth_id2, setcloth_id2] = useState(null);
  const [cloth_id3, setcloth_id3] = useState(null);
  const [cloth_id4, setcloth_id4] = useState(null);
  const [cloth_id5, setcloth_id5] = useState(null);
  const [cloth_id6, setcloth_id6] = useState(null);
  const [cloth_id9, setcloth_id9] = useState(null);
  const [cloth_id10, setcloth_id10] = useState(null);
  const [cloth_id13, setcloth_id13] = useState(null);

  const offset = 2;
  const span = 9;
  const qu_span = 2;
  // Work done (designer) state
  const [isDesignerImage, setIsDesignerImage] = useState(false);
  const [isDigitizersImageForUpload, setIsDigitizersImageForUpload] = useState(false);
  const [workDoneChecked, setWorkDoneChecked] = useState(false);
  const [isWorkDoneModalVisible, setIsWorkDoneModalVisible] = useState(false);

  // State for img1 and main_image previews
  const [img1Preview, setImg1Preview] = useState(null);
  const [img1File, setImg1File] = useState(null);
  const [img1InputKey, setImg1InputKey] = useState(0);
  const [img1ImageName, setImg1ImageName] = useState("");
  const [mainImagePreview, setMainImagePreview] = useState(null);
  const [mainImageFile, setMainImageFile] = useState(null);
  const [mainImageInputKey, setMainImageInputKey] = useState(0);

  // Handle image file selection
  // Render an uploaded file preview — handles PDF and image data URLs
  const renderFilePreview = (dataUrl, file, maxHeight = "200px") => {
    const isPdf = file?.type === "application/pdf" || (typeof dataUrl === "string" && dataUrl.startsWith("data:application/pdf"));
    if (isPdf) {
      return (
        <a href={dataUrl} target="_blank" rel="noopener noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#cf1322", textDecoration: "none" }}>
          <FilePdfOutlined style={{ fontSize: "48px", marginBottom: "8px" }} />
          <span style={{ fontSize: "12px" }}>PDF — Click to view</span>
        </a>
      );
    }
    return <img src={dataUrl} alt="preview" style={{ width: "100%", maxHeight, objectFit: "contain", borderRadius: "4px" }} />;
  };

  // Render an existing file URL (PDF or image) from the server
  const renderExistingFile = (fileUrl, altText, maxHeight = "200px") => {
    const lower = fileUrl ? String(fileUrl).toLowerCase() : "";
    const isPdf = lower.endsWith(".pdf");
    if (isPdf) {
      return (
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#cf1322", textDecoration: "none" }}>
          <FilePdfOutlined style={{ fontSize: "48px", marginBottom: "8px" }} />
          <span style={{ fontSize: "12px" }}>PDF — Click to view</span>
        </a>
      );
    }
    return (
      <img
        src={fileUrl}
        alt={altText}
        style={{ width: "100%", maxHeight, objectFit: "contain", borderRadius: "4px" }}
        onError={(e) => { e.target.style.display = "none"; if (e.target.nextSibling) e.target.nextSibling.style.display = "flex"; }}
      />
    );
  };

  const handleImageChange = (side, file) => {
    if (file) {
      setCapSideImages((prev) => ({
        ...prev,
        [side]: file,
      }));

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prev) => ({
          ...prev,
          [side]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle image removal
  const handleImageRemove = (side) => {
    setCapSideImages((prev) => ({
      ...prev,
      [side]: null,
    }));
    setImagePreviews((prev) => ({
      ...prev,
      [side]: null,
    }));
  };

  // Handle img1 image selection
  const handleImg1Change = (file) => {
    if (file) {
      setImg1File(file);
      setShouldDeleteImg1(false); // Clear deletion flag when new image is selected
      const reader = new FileReader();
      reader.onloadend = () => {
        setImg1Preview(reader.result);
      };
      reader.readAsDataURL(file);
      // Set default image name from embr_Front field
      const embrFrontValue = form.getFieldValue("embr_Front");
      if (embrFrontValue) {
        setImg1ImageName(embrFrontValue);
      }
    }
  };

  // Handle form values change to update image name when embr_Front changes
  const handleFormValuesChange = (changedValues, allValues) => {
    if (changedValues.embr_Front !== undefined && img1File) {
      const newEmbrFrontValue = changedValues.embr_Front;
      // Update image name if it's empty (user hasn't set a custom name yet)
      if (newEmbrFrontValue && !img1ImageName) {
        setImg1ImageName(newEmbrFrontValue);
      }
    }
  };

  // Handle img1 image removal
  const handleImg1Remove = () => {
    setImg1File(null);
    setImg1Preview(null);
    setImg1ImageName("");
    setImg1InputKey(prev => prev + 1); // Reset file input
    // If in update mode and there's an existing img1, mark it for deletion
    if (formValues && formValues?.img1) {
      setShouldDeleteImg1(true);
    }
  };

  // Handle main image selection
  const handleMainImageChange = (file) => {
    if (file) {
      setMainImageFile(file);
      setShouldDeleteMainImage(false); // Clear deletion flag when new image is selected
      const reader = new FileReader();
      reader.onloadend = () => {
        setMainImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle main image removal
  const handleMainImageRemove = () => {
    setMainImageFile(null);
    setMainImagePreview(null);
    setMainImageInputKey(prev => prev + 1); // Reset file input
    // If in update mode and there's an existing main_image, mark it for deletion
    if (formValues && formValues?.main_image) {
      setShouldDeleteMainImage(true);
    }
  };

  // Handle deletion of existing image (update mode)
  const handleDeleteExistingImage = async (side) => {
    const existingImage = existingImages[side];
    if (existingImage && existingImage.id) {
      try {
        const result = await deleteJobcardImage(existingImage.id).unwrap();
        // Remove from existing images
        setExistingImages((prev) => {
          const updated = { ...prev };
          delete updated[side];
          return updated;
        });
        // Add to images to delete list (for tracking)
        setImagesToDelete((prev) => [...prev, existingImage.id]);
        message.success(`Deleted ${side} image`);
        // The query will automatically refetch due to cache invalidation
      } catch (error) {
        message.error(`Failed to delete ${side} image`);
        console.error("Delete image error:", error);
      }
    }
  };

  // Handle modal confirmation
  const handleModalConfirm = () => {
    // Prevent confirmation if creation is already in progress
    if (isCreationInProgress) {
      message.warning("Please wait for the current creation to complete.");
      return;
    }
    setIsModalVisible(false);
    if (pendingFormValues) {
      // Determine if any side image was selected during creation
      const anySideChecked = Object.values(capSideImages).some(Boolean);
      setIsDigitizersImageForUpload(anySideChecked);
      handleFormSubmit(
        pendingFormValues,
        createJobcard,
        thisfun,
        creatCapResponseInfo.status,
        colors,
      );
    }
    setPendingFormValues(null);
    setShouldBypassConfirmation(false);
  };

  // Handle modal cancellation
  const handleModalCancel = () => {
    setIsModalVisible(false);
    setPendingFormValues(null);
    setShouldBypassConfirmation(false);
  };

  // Handle no images modal - user wants to continue
  const handleNoImagesConfirm = () => {
    setIsNoImagesModalVisible(false);
    setShouldBypassConfirmation(true);

    if (pendingFormValues) {
      // Bypass confirmation modal and directly create jobcard
      const anySideChecked = Object.values(capSideImages).some(Boolean);
      setIsDigitizersImageForUpload(anySideChecked);
      handleFormSubmit(
        pendingFormValues,
        createJobcard,
        thisfun,
        creatCapResponseInfo.status,
        colors,
      );
    }
    setPendingFormValues(null);
  };

  // Handle no images modal - user wants to upload images
  const handleNoImagesCancel = () => {
    setIsNoImagesModalVisible(false);
    setPendingFormValues(null);
    setShouldBypassConfirmation(false);
    // User can now upload images and try again
  };

  // Work done checkbox handlers
  const handleWorkDoneClick = (e) => {
    // Prevent default toggle; we control it via modal confirmation
    e.preventDefault();
    // Ensure the submit confirmation modal is not open simultaneously
    setIsModalVisible(false);
    setIsWorkDoneModalVisible(true);
  };
  const handleWorkDoneConfirm = () => {
    setWorkDoneChecked(true);
    setIsDesignerImage(true);
    setIsWorkDoneModalVisible(false);
  };
  const handleWorkDoneCancel = () => {
    // Keep unchecked when cancelled
    setWorkDoneChecked(false);
    setIsDesignerImage(false);
    setIsWorkDoneModalVisible(false);
  };
  // send all jobcard data to this createJobcard
  const [createJobcard, createResponseInfo] = useCreateJobcardMutation();
  const [createJobcardVersion, createVersionResponseInfo] = useCreateJobcardVersionMutation();

  // send cap data to createCap

  // update jobcard
  const [updateJobcard, updateResponseInfo] = useUpdateJobcardMutation();

  // upload jobcard images
  const [uploadJobcardImages, uploadImagesResponseInfo] = useUploadJobcardImagesMutation();

  // delete jobcard images
  const [deleteJobcardImage, deleteImageResponseInfo] = useDeleteJobcardImageMutation();

  // Confirmation modal state
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pendingFormValues, setPendingFormValues] = useState(null);

  // No images warning modal state
  const [isNoImagesModalVisible, setIsNoImagesModalVisible] = useState(false);
  const [shouldBypassConfirmation, setShouldBypassConfirmation] = useState(false);

  // Confirmation before creating a jobcard version while editing
  const handleCreateVersion = () => {
    Modal.confirm({
      title: "Create Version",
      content: "Are you sure you want to create a new version from this jobcard?",
      onOk: async () => {
        if (isCreationInProgress || createVersionResponseInfo.isLoading) {
          message.warning("Please wait for the current operation to complete.");
          return;
        }
        try {
          await createJobcardVersion(formValues.id).unwrap();
        } catch (error) {
          // Error handling is done in useEffect
          console.error("Error creating version:", error);
        }
      },
    });
  };

  // Intercept clicks inside the buttons area and show confirmation for Create Version
  const handleSpaceClick = (e) => {
    try {
      const target = e.target;
      const text = (target && (target.innerText || target.textContent)) || "";
      if (text.trim() === "Create Version") {
        e.stopPropagation();
        e.preventDefault();
        handleCreateVersion();
      }
    } catch (err) {
      // Fail silently
    }
  };

  // Image upload state for 6 cap sides
  const [capSideImages, setCapSideImages] = useState({
    Front: null,
    "Right Middle": null,
    "Left Middle": null,
    Back: null,
    Velcro: null,
    Visor: null,
  });

  // Image previews
  const [imagePreviews, setImagePreviews] = useState({
    Front: null,
    "Right Middle": null,
    "Left Middle": null,
    Back: null,
    Velcro: null,
    Visor: null,
  });

  // Embroidery image upload state for 6 cap sides
  const [embroiderySideImages, setEmbroiderySideImages] = useState({
    Front: null,
    "Right Middle": null,
    "Left Middle": null,
    Back: null,
    Velcro: null,
    Visor: null,
  });

  const handleEmbroideryImageChange = (side, file) => {
    if (file) {
      setEmbroiderySideImages((prev) => ({
        ...prev,
        [side]: file,
      }));
    }
  };

  const handleEmbroideryImageRemove = (side) => {
    setEmbroiderySideImages((prev) => ({
      ...prev,
      [side]: null,
    }));
  };

  // Existing images from jobcard (for update mode)
  const [existingImages, setExistingImages] = useState({});

  // Existing digitizer images from jobcard (for digitizer stage update mode)
  const [existingDigitizerImages, setExistingDigitizerImages] = useState({});

  // Images to delete (for update mode)
  const [imagesToDelete, setImagesToDelete] = useState([]);

  // Track if main_image and img1 should be deleted (for update mode)
  const [shouldDeleteMainImage, setShouldDeleteMainImage] = useState(false);
  const [shouldDeleteImg1, setShouldDeleteImg1] = useState(false);

  // Fetch jobcard images when in update mode
  const { data: jobcardImageDetail } = useGetJobcardImageDetailQuery(formValues?.id, {
    skip: !formValues?.id,
  });

  const [updateManufacture_cap, updateManuResponseInfo] =
    useUpdateManufacturerMutation();

  // Designer stage (digitizer) is now auto-derived from side selection during creation

  // Reset deletion flags when formValues changes (e.g., loading a different jobcard)
  useEffect(() => {
    setShouldDeleteMainImage(false);
    setShouldDeleteImg1(false);
    setMainImageFile(null);
    setMainImagePreview(null);
    setImg1File(null);
    setImg1Preview(null);
  }, [formValues?.id]);

  useEffect(() => {
    // Surface manufacturer update errors, but avoid duplicating jobcard update
    if (formValues && updateManuResponseInfo?.status === "rejected") {
      message.error(updateManuResponseInfo?.error?.data?.message || "Failed to update manufactured cap");
    }
  }, [updateManuResponseInfo, formValues]);
  // const clients = useSelector((state) => state.JobCard.clients);

  const role = useSelector(roleSelector);

  const showPriority = () => [ROLES.ADMIN].includes(role);

  const showAdmin = () => showPriority();

  useEffect(() => {
    dispatch(allDropDowns());
    // dispatch(fetchColor(""))
    getUpadtedcolor();
    getCapName();
  }, []);

  useEffect(() => {
    setRender(false);
    console.log(formValues);
    if (formValues) {
      const client = clients?.find((c) => c.id === formValues.client);
      setSelectedClient(client);
      setAddressType(formValues.shipping_address === client?.billing_address ? 'billing' : 'shipping');

      // Prefill technique selects from API `techniques` map when editing
      const techniquesMap = formValues?.techniques || {};
      const techniquePrefill = {
        technique_front: techniquesMap?.front ?? undefined,
        technique_back: techniquesMap?.back ?? undefined,
        technique_middle: techniquesMap?.middle ?? undefined,
        technique_top: techniquesMap?.top ?? undefined,
        technique_under: techniquesMap?.under ?? undefined,
        technique_cross_band: techniquesMap?.cross_band ?? undefined,
      };

      // Prefill eyelet details from API `eyelet_details` map when editing
      const eyeletDetails = formValues?.eyelet_details || formValues?.eyelet_info || {};
      const eyeletPrefill = {};

      // Helper function to find the "COLOR" option in eyelet arrays
      const findColorOption = (eyeletArray) => {
        if (!eyeletArray || !Array.isArray(eyeletArray)) return null;
        return eyeletArray.find(opt => {
          const optStr = typeof opt === 'string' ? opt : (opt?.label || opt?.value || '');
          return String(optStr).toUpperCase().includes('COLOR');
        }) || null;
      };

      // Helper function to find matching color value in colors array
      // The stored value could be an ID (number) or color name (string)
      const findMatchingColorValue = (storedColorValue, colorsArray) => {
        if (!storedColorValue || !colorsArray || !Array.isArray(colorsArray)) return null;

        // Try to find by ID first (if stored value is a number or numeric string)
        const numericValue = typeof storedColorValue === 'number' ? storedColorValue : parseInt(storedColorValue, 10);
        if (!isNaN(numericValue)) {
          const byId = colorsArray.find(c => c.id === numericValue);
          if (byId) return byId.id ?? byId.color;
        }

        // Try to find by color name (exact match)
        const byName = colorsArray.find(c => c.color === storedColorValue);
        if (byName) return byName.id ?? byName.color;

        // Try to find by color name (case-insensitive)
        const byNameCaseInsensitive = colorsArray.find(c =>
          c.color && String(c.color).toLowerCase() === String(storedColorValue).toLowerCase()
        );
        if (byNameCaseInsensitive) return byNameCaseInsensitive.id ?? byNameCaseInsensitive.color;

        // Return original value if no match found (will be set but might not display)
        return storedColorValue;
      };

      // Only process eyelet details if selections are available
      // Check the actual eyelet option values from formValues to determine if we should set colors
      if (selections) {
        // Check if front eyelet option includes "COLOR"
        const frontEyeletOption = formValues?.eyelet_front;
        const frontEyeletStr = typeof frontEyeletOption === 'string' ? frontEyeletOption : (frontEyeletOption?.label || frontEyeletOption?.value || '');
        const isFrontColorOption = String(frontEyeletStr).toUpperCase().includes('COLOR');

        // Process front eyelet - only set color if option includes "COLOR" AND is_eyelet_enabled is true
        if (isFrontColorOption && eyeletDetails?.front?.is_eyelet_enabled && eyeletDetails?.front?.color) {
          const colorOption = findColorOption(selections?.eyelet_front_array);
          if (colorOption) {
            eyeletPrefill.eyelet_front = colorOption;
          }
          // Find matching color value from colors array
          const matchedColorValue = findMatchingColorValue(eyeletDetails.front.color, uniqueEyeletColors);
          if (matchedColorValue) {
            eyeletPrefill.eyelet_front_color_sel = matchedColorValue;
          } else {
            // Fallback to original value if colors not loaded yet
            eyeletPrefill.eyelet_front_color_sel = eyeletDetails.front.color;
          }
        } else {
          // Clear color if option is not "COLOR"
          eyeletPrefill.eyelet_front_color_sel = undefined;
        }

        // Check if back eyelet option includes "COLOR"
        const backEyeletOption = formValues?.eyelet_back;
        const backEyeletStr = typeof backEyeletOption === 'string' ? backEyeletOption : (backEyeletOption?.label || backEyeletOption?.value || '');
        const isBackColorOption = String(backEyeletStr).toUpperCase().includes('COLOR');

        // Process back eyelet - only set color if option includes "COLOR" AND is_eyelet_enabled is true
        if (isBackColorOption && eyeletDetails?.back?.is_eyelet_enabled && eyeletDetails?.back?.color) {
          const colorOption = findColorOption(selections?.eyelet_back_array);
          if (colorOption) {
            eyeletPrefill.eyelet_back = colorOption;
          }
          // Find matching color value from colors array
          const matchedColorValue = findMatchingColorValue(eyeletDetails.back.color, uniqueEyeletColors);
          if (matchedColorValue) {
            eyeletPrefill.eyelet_back_color_sel = matchedColorValue;
          } else {
            // Fallback to original value if colors not loaded yet
            eyeletPrefill.eyelet_back_color_sel = eyeletDetails.back.color;
          }
        } else {
          // Clear color if option is not "COLOR"
          eyeletPrefill.eyelet_back_color_sel = undefined;
        }

        // Check if middle eyelet option includes "COLOR"
        const middleEyeletOption = formValues?.eyelet_middle;
        const middleEyeletStr = typeof middleEyeletOption === 'string' ? middleEyeletOption : (middleEyeletOption?.label || middleEyeletOption?.value || '');
        const isMiddleColorOption = String(middleEyeletStr).toUpperCase().includes('COLOR');

        // Process middle eyelet - only set color if option includes "COLOR" AND is_eyelet_enabled is true
        if (isMiddleColorOption && eyeletDetails?.middle?.is_eyelet_enabled && eyeletDetails?.middle?.color) {
          const colorOption = findColorOption(selections?.eyelet_middle_array);
          if (colorOption) {
            eyeletPrefill.eyelet_middle = colorOption;
          }
          // Find matching color value from colors array
          const matchedColorValue = findMatchingColorValue(eyeletDetails.middle.color, uniqueEyeletColors);
          if (matchedColorValue) {
            eyeletPrefill.eyelet_middle_color_sel = matchedColorValue;
          } else {
            // Fallback to original value if colors not loaded yet
            eyeletPrefill.eyelet_middle_color_sel = eyeletDetails.middle.color;
          }
        } else {
          // Clear color if option is not "COLOR"
          eyeletPrefill.eyelet_middle_color_sel = undefined;
        }
      }

      setInitialValues({
        ...formValues,
        ...techniquePrefill,
        ...eyeletPrefill,
        date: formValues?.date ? moment(formValues?.date, "DD/MM/YYYY") : null,
        deliver_date: formValues?.deliver_date
          ? moment(formValues?.deliver_date, "DD/MM/YYYY")
          : null,
        shipping_address: formValues.shipping_address,
      });

      // Images will be loaded from jobcardImageDetail API response
    } else {
      // When creating a new job card, set current date as initial value
      setInitialValues({
        date: moment(), // Set current date
      });
    }
    setRender(true);
  }, [formValues, clients, selections]);

  // Update eyelet color values when colors are loaded (for edit mode)
  useEffect(() => {
    if (formValues?.id && colors && selections && form) {
      const eyeletDetails = formValues?.eyelet_details || formValues?.eyelet_info || {};

      // Helper function to find the "COLOR" option in eyelet arrays
      const findColorOption = (eyeletArray) => {
        if (!eyeletArray || !Array.isArray(eyeletArray)) return null;
        return eyeletArray.find(opt => {
          const optStr = typeof opt === 'string' ? opt : (opt?.label || opt?.value || '');
          return String(optStr).toUpperCase().includes('COLOR');
        }) || null;
      };

      // Helper function to find matching color value in colors array
      const findMatchingColorValue = (storedColorValue, colorsArray) => {
        if (!storedColorValue || !colorsArray || !Array.isArray(colorsArray)) return null;

        // Try to find by ID first (if stored value is a number or numeric string)
        const numericValue = typeof storedColorValue === 'number' ? storedColorValue : parseInt(storedColorValue, 10);
        if (!isNaN(numericValue)) {
          const byId = colorsArray.find(c => c.id === numericValue);
          if (byId) return byId.id ?? byId.color;
        }

        // Try to find by color name (exact match)
        const byName = colorsArray.find(c => c.color === storedColorValue);
        if (byName) return byName.id ?? byName.color;

        // Try to find by color name (case-insensitive)
        const byNameCaseInsensitive = colorsArray.find(c =>
          c.color && String(c.color).toLowerCase() === String(storedColorValue).toLowerCase()
        );
        if (byNameCaseInsensitive) return byNameCaseInsensitive.id ?? byNameCaseInsensitive.color;

        return null;
      };

      // Check actual eyelet option values from formValues
      const frontEyeletOption = formValues?.eyelet_front;
      const frontEyeletStr = typeof frontEyeletOption === 'string' ? frontEyeletOption : (frontEyeletOption?.label || frontEyeletOption?.value || '');
      const isFrontColorOption = String(frontEyeletStr).toUpperCase().includes('COLOR');

      // Update front eyelet if option includes "COLOR" and is_eyelet_enabled is true
      if (isFrontColorOption && eyeletDetails?.front?.is_eyelet_enabled && eyeletDetails?.front?.color) {
        const colorOption = findColorOption(selections?.eyelet_front_array);
        if (colorOption) {
          form.setFieldsValue({ eyelet_front: colorOption });
        }
        const matchedColorValue = findMatchingColorValue(eyeletDetails.front.color, uniqueEyeletColors);
        if (matchedColorValue) {
          form.setFieldsValue({ eyelet_front_color_sel: matchedColorValue });
        }
      } else {
        // Clear color if option is not "COLOR" or eyelet is not enabled
        form.setFieldsValue({ eyelet_front_color_sel: undefined });
      }

      // Check actual eyelet option values from formValues
      const backEyeletOption = formValues?.eyelet_back;
      const backEyeletStr = typeof backEyeletOption === 'string' ? backEyeletOption : (backEyeletOption?.label || backEyeletOption?.value || '');
      const isBackColorOption = String(backEyeletStr).toUpperCase().includes('COLOR');

      // Update back eyelet if option includes "COLOR" and is_eyelet_enabled is true
      if (isBackColorOption && eyeletDetails?.back?.is_eyelet_enabled && eyeletDetails?.back?.color) {
        const colorOption = findColorOption(selections?.eyelet_back_array);
        if (colorOption) {
          form.setFieldsValue({ eyelet_back: colorOption });
        }
        const matchedColorValue = findMatchingColorValue(eyeletDetails.back.color, uniqueEyeletColors);
        if (matchedColorValue) {
          form.setFieldsValue({ eyelet_back_color_sel: matchedColorValue });
        }
      } else {
        // Clear color if option is not "COLOR" or eyelet is not enabled
        form.setFieldsValue({ eyelet_back_color_sel: undefined });
      }

      // Check actual eyelet option values from formValues
      const middleEyeletOption = formValues?.eyelet_middle;
      const middleEyeletStr = typeof middleEyeletOption === 'string' ? middleEyeletOption : (middleEyeletOption?.label || middleEyeletOption?.value || '');
      const isMiddleColorOption = String(middleEyeletStr).toUpperCase().includes('COLOR');

      // Update middle eyelet if option includes "COLOR" and is_eyelet_enabled is true
      if (isMiddleColorOption && eyeletDetails?.middle?.is_eyelet_enabled && eyeletDetails?.middle?.color) {
        const colorOption = findColorOption(selections?.eyelet_middle_array);
        if (colorOption) {
          form.setFieldsValue({ eyelet_middle: colorOption });
        }
        const matchedColorValue = findMatchingColorValue(eyeletDetails.middle.color, uniqueEyeletColors);
        if (matchedColorValue) {
          form.setFieldsValue({ eyelet_middle_color_sel: matchedColorValue });
        }
      } else {
        // Clear color if option is not "COLOR" or eyelet is not enabled
        form.setFieldsValue({ eyelet_middle_color_sel: undefined });
      }
    }
  }, [colors, formValues?.id, formValues?.eyelet_front, formValues?.eyelet_back, formValues?.eyelet_middle, formValues?.eyelet_details, formValues?.eyelet_info, selections, form]);

  // Load existing cap images from API response (only designer images, not digitizer)
  useEffect(() => {
    if (jobcardImageDetail && jobcardImageDetail.images && Array.isArray(jobcardImageDetail.images)) {
      const existing = {};
      jobcardImageDetail.images
        .filter(img => img && !img.is_degitizer_image) // Only designer images
        .forEach(img => {
          if (img.side) {
            const imageUrl = img.designer_image_url || img.designer_image;
            const fullUrl = imageUrl?.startsWith("http") ? imageUrl : `${url}${imageUrl?.startsWith("/") ? "" : "/"}${imageUrl || ""}`;
            existing[img.side] = { id: img.id, url: fullUrl, image: img };
          }
        });
      setExistingImages(existing);

      const existingDigitizer = {};
      jobcardImageDetail.images
        .filter(img => img && img.is_degitizer_image) // Only digitizer images
        .forEach(img => {
          if (img.side) {
            const imageUrl = img.degitizer_image_url || img.degitizer_image || img.designer_image_url || img.designer_image;
            const fullUrl = imageUrl?.startsWith("http") ? imageUrl : `${url}${imageUrl?.startsWith("/") ? "" : "/"}${imageUrl || ""}`;
            existingDigitizer[img.side] = { id: img.id, url: fullUrl, image: img };
          }
        });
      setExistingDigitizerImages(existingDigitizer);
    } else if (!jobcardImageDetail && formValues?.id) {
      setExistingImages({});
      setExistingDigitizerImages({});
    }
  }, [jobcardImageDetail, formValues?.id]);

  // Check if digitizer work is done - if so, disable editing of cap side images
  const isDigitizerWorkDone = React.useMemo(() => {
    if (!formValues?.id || !jobcardImageDetail?.images) return false;

    // Consider work done only when every designer side has a digitizer counterpart
    const allImages = jobcardImageDetail.images || [];
    const designerSides = new Set(
      allImages
        .filter((img) => img && img.side && !img.is_degitizer_image)
        .map((img) => img.side)
    );
    const digitizerSides = new Set(
      allImages
        .filter((img) => img && img.side && img.is_degitizer_image)
        .map((img) => img.side)
    );

    if (designerSides.size > 0) {
      return Array.from(designerSides).every((side) => digitizerSides.has(side));
    }

    return false;
  }, [formValues?.id, jobcardImageDetail]);

  const [buckelbelt_quantity, setBuckelbelt_quantity] = useState();
  const [bulkle_belt_obj, setBulkle_belt_obj] = useState([]);
  const [o_ring_obj, setO_ring_obj] = useState([]);
  const [snappack_obj, setsnappack_obj] = useState([]);
  const [button_color_obj, setButton_color_obj] = useState([]);
  const [sweat_band_holding_obj, setSweat_band_holding_obj] = useState();
  const [buckel, setBuckel] = useState();
  const [bulkle_obj, setBulkle_obj] = useState([]);

  const buckle = (data) => {
    console.log(data);
    // const splitString = data.split(":");

    // Accessing the values before and after the colon
    // const belt_type = splitString[0].trim();
    // const belt_color = splitString[1].trim();
    const belt_type = data;
    console.log(belt_type);
    const quantities = colors?.reduce((acc, item) => {
      if (
        item.cap_data &&
        item.cap_data?.some(
          (capData) =>
            capData.cap_type === a &&
            item.cap_material === "BUCKLE" &&
            item.type === belt_type
        )
      ) {
        const matchingCapData = item.cap_data?.filter(
          (capData) =>
            capData.cap_type === a &&
            item.cap_material === "BUCKLE" &&
            item.type === belt_type
        );

        matchingCapData.forEach((capData) => {
          const entry = {
            cloth_id: item.id,
            cap_id: capData.id,
            quantity: capData.quantity,
          };
          acc.push(entry);
        });
      }
      return acc;
    }, []);

    // console.log("p",quantities)
    setBuckel(quantities[0].quantity);
    delete quantities[0].quantity;
    setBulkle_obj(quantities[0]);
  };




  const [interLINING, setInterLINING] = useState();











  useEffect(() => {
    setRender(false);
    if (selections) {
      setRender(true);
    }
  }, [selections]);
  const {
    error: failedToUpdate,
    isSuccess: updateSuccess,
    isLoading: updating,
  } = updateResponseInfo;
  const {
    error,
    isSuccess: createSuccess,
    isLoading: creating,
  } = createResponseInfo;
  if (error) message.error("Failed to create job cardsss");

  // Track all loading states for creation process
  const isCreatingCap = creatCapResponseInfo.isLoading;
  const isUploadingImages = uploadImagesResponseInfo.isLoading;
  const isCreatingJobcard = creating;

  // Combined loading state - true if any part of creation is in progress
  const isCreationInProgress = isCreatingCap || isCreatingJobcard || isUploadingImages;

  if (failedToUpdate) message.error("Failed to update job card");

  // Note: updateSuccess navigation is handled in onFinish for update mode
  // to allow image uploads to complete first

  // Handle image upload after jobcard creation
  useEffect(() => {
    if (createSuccess && createResponseInfo.data) {
      const jobCardId = createResponseInfo.data.id || createResponseInfo.data.data?.id;

      // Collect images that were selected
      const metadata = [];
      const files = [];

      Object.keys(capSideImages).forEach((side) => {
        if (capSideImages[side]) {
          const originalFile = capSideImages[side];
          const originalName = originalFile?.name || "";
          const dotIndex = originalName.lastIndexOf(".");
          const ext = dotIndex > -1 ? originalName.slice(dotIndex) : "";
          const safeSide = side.replace(/\s+/g, '_');
          const filename = `jobcard_${safeSide}${ext}`;
          metadata.push({ filename, side });

          // Create a new File object with the same extension to match metadata
          const renamedFile = new File([originalFile], filename, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
          });
          files.push(renamedFile);
        }
      });

      // Collect embroidery files
      const embMetadata = [];
      const embFiles = [];
      Object.keys(embroiderySideImages).forEach((side) => {
        if (embroiderySideImages[side]) {
          const originalFile = embroiderySideImages[side];
          const originalName = originalFile?.name || "";
          const dotIndex = originalName.lastIndexOf(".");
          const ext = dotIndex > -1 ? originalName.slice(dotIndex) : "";
          const safeSide = side.replace(/\s+/g, '_');
          const filename = `jobcard_emb_${safeSide}${ext}`;
          embMetadata.push({ filename, side });

          const renamedFile = new File([originalFile], filename, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
          });
          embFiles.push(renamedFile);
        }
      });

      // Only upload if there are images
      if (files.length > 0 && jobCardId) {
        uploadJobcardImages({
          job_card_id: jobCardId,
          // Designer/Admin uploads during creation should always be marked as NOT digitizer images
          is_degitizer_image: false,
          metadata,
          files,
        });
      }

      if (embFiles.length > 0 && jobCardId) {
        uploadJobcardImages({
          job_card_id: jobCardId,
          is_degitizer_image: false,
          is_embroidary_image: true,
          metadata: embMetadata,
          files: embFiles,
        });
      }

      if (files.length === 0 && embFiles.length === 0) {
        // No images to upload, just navigate
        message.success("Jobcard created successfully!");
        navigate("/jobcard");
      }
    }
  }, [createSuccess, createResponseInfo.data, capSideImages, embroiderySideImages]);

  // Handle image upload response
  useEffect(() => {
    if (uploadImagesResponseInfo.isSuccess) {
      message.success("Jobcard and images uploaded successfully!");
      navigate("/jobcard");
    }
    if (uploadImagesResponseInfo.isError) {
      message.error("Jobcard created but image upload failed. Please try uploading images again.");
      navigate("/jobcard");
    }
  }, [uploadImagesResponseInfo.isSuccess, uploadImagesResponseInfo.isError]);

  // Handle version creation response
  useEffect(() => {
    if (createVersionResponseInfo.isSuccess) {
      message.success("Jobcard version created successfully!");
      navigate("/jobcard");
    }
    if (createVersionResponseInfo.isError) {
      message.error("Failed to create jobcard version. Please try again.");
    }
  }, [createVersionResponseInfo.isSuccess, createVersionResponseInfo.isError, navigate]);

  if (createSuccess && !uploadImagesResponseInfo.isSuccess && !uploadImagesResponseInfo.isError) {
    // Jobcard created, waiting for image upload or no images to upload
    return render && !(loading || dropdownLoading) && Object.keys(selections).length > 0 ? (
      <Style>
        {/* Full-screen overlay with blur during image upload */}
        {isCreationInProgress && (
          <div className="creation-overlay">
            <div className="overlay-backdrop"></div>
            <div className="overlay-loader">
              <Loader />
              <p className="loading-text">Uploading images, please wait...</p>
            </div>
          </div>
        )}
      </Style>
    ) : null;
  }
  return render && !(loading || dropdownLoading) && Object.keys(selections).length > 0 ? (
    <Style>
      {/* Full-screen overlay with blur during creation */}
      {isCreationInProgress && (
        <div className="creation-overlay">
          <div className="overlay-backdrop"></div>
          <div className="overlay-loader">
            <Loader />
            <p className="loading-text">Creating jobcard, please wait...</p>
          </div>
        </div>
      )}
      {(updating || creating) && !isCreationInProgress && <Loader />}
      {/* <button onClick={thisfun}>LOTS OF FUNN</button> */}
      <Form
        form={form}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 14,
        }}
        layout="horizontal"
        disabled={isCreationInProgress}
        onValuesChange={handleFormValuesChange}
        onFinish={async (values) => {
          // Prevent submission if creation is in progress
          if (isCreationInProgress) {
            message.warning("Please wait for the current creation to complete.");
            return;
          }
          if (formValues) {
            values.main_fabric_Front_color = frontcolor;
            values.main_fabric_Back_color = backcolor;
            values.main_fabric_Middle_color = middlecolor;
            values.main_fabric_Top_color = topcolor;
            values.main_fabric_Under_color = undercolor;
            values.piping_color = pipingcolor;
            // Ensure Brim Top/Under/Cross Band colors are included if selected
            if (brimtopcolor && brimtopcolor !== "pending") {
              values.main_fabric_Brim_Top_color = brimtopcolor;
            }
            if (brimundercolor && brimundercolor !== "pending") {
              values.main_fabric_Brim_Under_color = brimundercolor;
            }
            if (crossbandcolor && crossbandcolor !== "pending") {
              values.main_fabric_Cross_Band_color = crossbandcolor;
            }

            // Include state files for img1 and main_image if they exist
            if (img1File) {
              values.img1 = { target: { files: [img1File] } };
            } else if (shouldDeleteImg1) {
              // Mark img1 for deletion by setting it to null
              values.img1 = null;
            }
            if (mainImageFile) {
              values.main_image = { target: { files: [mainImageFile] } };
            } else if (shouldDeleteMainImage) {
              // Mark main_image for deletion by setting it to null
              values.main_image = null;
            }

            // Handle cap side images for update mode
            const metadata = [];
            const files = [];

            // --- NEW: keep embroidery side flags in sync on UPDATE as well ---
            // We consider both newly selected images (capSideImages)
            // and already existing images (existingImages) so flags
            // correctly reflect whether a side has any image at all.
            const sideKeyMap = {
              Front: "is_front",
              "Right Middle": "is_right_middle",
              "Left Middle": "is_left_middle",
              Back: "is_back",
              Velcro: "is_velcro",
              Visor: "is_visor",
            };

            Object.keys(sideKeyMap).forEach((side) => {
              const hasNewImage = Boolean(capSideImages[side]);
              const hasExistingImage = Boolean(existingImages[side]);
              values[sideKeyMap[side]] = hasNewImage || hasExistingImage;
            });

            // Check if digitizer work is done - if so, prevent image uploads
            if (isDigitizerWorkDone) {
              message.warning("Cannot update cap side images: Digitizer work has been completed.");
              // Still update the jobcard, just skip image uploads
              handleFormUpdate(
                {
                  ...values,
                  id: formValues?.id,
                },
                updateJobcard,
                thisfun,
              );
              setTimeout(() => {
                message.success("Jobcard updated successfully!");
                navigate("/jobcard");
              }, 500);
            } else {
              Object.keys(capSideImages).forEach((side) => {
                if (capSideImages[side]) {
                  const originalFile = capSideImages[side];
                  const originalName = originalFile?.name || "";
                  const dotIndex = originalName.lastIndexOf(".");
                  const ext = dotIndex > -1 ? originalName.slice(dotIndex) : "";
                  const safeSide = side.replace(/\s+/g, '_');
                  const filename = `jobcard_${safeSide}${ext}`;
                  metadata.push({ filename, side });

                  // Create a new File object with the same extension to match metadata
                  const renamedFile = new File([originalFile], filename, {
                    type: originalFile.type,
                    lastModified: originalFile.lastModified,
                  });
                  files.push(renamedFile);
                }
              });

              // Update jobcard first
              handleFormUpdate(
                {
                  ...values,
                  id: formValues?.id,
                },
                updateJobcard,
                thisfun,
              );

              // Upload new images if any
              if (files.length > 0 && formValues?.id) {
                try {
                  await uploadJobcardImages({
                    job_card_id: formValues.id,
                    is_degitizer_image: formValues?.is_degitizer_stage === true || formValues?.is_degitizer_stage === "true",
                    metadata,
                    files,
                  }).unwrap();
                  message.success("Jobcard and images updated successfully!");
                  navigate("/jobcard");
                } catch (error) {
                  message.error("Jobcard updated but image upload failed. Please try uploading images again.");
                  console.error("Image upload error:", error);
                  // Still navigate even if image upload fails
                  navigate("/jobcard");
                }
              } else {
                // No new images to upload, just navigate after a short delay to allow update to complete
                setTimeout(() => {
                  message.success("Jobcard updated successfully!");
                  navigate("/jobcard");
                }, 500);
              }
            }
          } else {
            values.main_fabric_Front_color = frontcolor;
            values.main_fabric_Back_color = backcolor;
            values.main_fabric_Middle_color = middlecolor;
            values.main_fabric_Top_color = topcolor;
            values.main_fabric_Under_color = undercolor;

            values.piping_color = pipingcolor;
            // Ensure Brim Top/Under/Cross Band colors are included if selected
            if (brimtopcolor && brimtopcolor !== "pending") {
              values.main_fabric_Brim_Top_color = brimtopcolor;
            }
            if (brimundercolor && brimundercolor !== "pending") {
              values.main_fabric_Brim_Under_color = brimundercolor;
            }
            if (crossbandcolor && crossbandcolor !== "pending") {
              values.main_fabric_Cross_Band_color = crossbandcolor;
            }

            // Include state files for img1 and main_image if they exist
            if (img1File) {
              values.img1 = { target: { files: [img1File] } };
            }
            if (mainImageFile) {
              values.main_image = { target: { files: [mainImageFile] } };
            }

            // Auto-set embroidery side flags from selected images
            const sideKeyMap = {
              "Front": "is_front",
              "Right Middle": "is_right_middle",
              "Left Middle": "is_left_middle",
              "Back": "is_back",
              "Velcro": "is_velcro",
              "Visor": "is_visor",
            };
            Object.keys(sideKeyMap).forEach((side) => {
              values[sideKeyMap[side]] = Boolean(capSideImages[side]);
            });

            // Check if any side images are uploaded
            const hasAnySideImages = Object.values(capSideImages).some(Boolean);

            if (!hasAnySideImages) {
              // No images uploaded - show warning modal
              setPendingFormValues(values);
              setIsNoImagesModalVisible(true);
            } else {
              // Images uploaded - show confirmation modal
              setPendingFormValues(values);
              setIsModalVisible(true);
            }
          }
        }}
        initialValues={initialValues}
      >
        {showPriority() && (
          <Form.Item name="priority" label="Priority">
            <Slider
              style={{
                width: "500px",
                marginLeft: "2rem",
              }}
              marks={{
                0: {
                  style: {
                    color: "#1a1a1a",
                  },
                  label: "None",
                },
                1: {
                  style: {
                    color: "#bee835",
                  },
                  label: "Low",
                },
                2: {
                  style: {
                    color: "#46e07e",
                  },
                  label: "Medium",
                },
                3: {
                  style: {
                    color: "#5a46e0",
                  },
                  label: "High",
                },
                4: {
                  style: {
                    color: "#f54033",
                  },
                  label: "Critical",
                },
              }}
              defaultValue={formValues?.priority}
              max={4}
            />
          </Form.Item>
        )}

        <Form.Item label="Client" name="client" rules={[{ required: true }]}>
          <Select
            showSearch
            optionFilterProp="children"
            onChange={(value) => {
              const client = clients?.find((c) => c.id === value);
              setSelectedClient(client);
              // Combine shipping address details into a single string
              const shippingAddress = [
                client?.shipping_address,
                client?.shipping_city,
                client?.shipping_state,
                client?.shipping_country,
                client?.shipping_pincode,
              ]
                .filter(Boolean)
                .join(", ");
              form.setFieldsValue({
                shipping_address: shippingAddress || "",
              });
              setAddressType("shipping");
            }}
            onSearch={(value) => { }}
          >
            {clients?.map((client) => (
              <Select.Option key={client.id} value={client.id}>
                {client.company_name}, {client.billing_address}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {selectedClient && (
          <div className="sub-section">
            <div className="title">Shipping Address</div>
            {/* <Form.Item label=""> */}
            <Row gutter={16} style={{ marginTop: "16px" }}>
              {/* Shipping Address Card */}
              <Col span={8}>
                <div
                  className={`address-card ${addressType === "shipping" ? "selected" : ""
                    }`}
                  onClick={() => {
                    setAddressType("shipping");
                    const shippingAddress = [
                      selectedClient.shipping_address,
                      selectedClient.shipping_city,
                      selectedClient.shipping_state,
                      selectedClient.shipping_country,
                      selectedClient.shipping_pincode,
                    ]
                      .filter(Boolean)
                      .join(", ");
                    form.setFieldsValue({
                      shipping_address: shippingAddress || "",
                    });
                  }}
                  style={{
                    border:
                      addressType === "shipping"
                        ? "2px solid #1890ff"
                        : "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "16px",
                    cursor: "pointer",
                    backgroundColor:
                      addressType === "shipping" ? "#f0f8ff" : "#fafafa",
                    transition: "all 0.3s ease",
                    position: "relative",
                    height: "140px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px",
                      justifyContent: "space-between",
                    }}
                  >
                    <h4 style={{ margin: 0, color: "#1890ff" }}>
                      Shipping Address
                    </h4>
                    {addressType === "shipping" && (
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "#1890ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ color: "white", fontSize: "12px" }}>
                          ✓
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="address-details">
                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                      {[
                        selectedClient.shipping_address,
                        selectedClient.shipping_city,
                        selectedClient.shipping_state,
                        selectedClient.shipping_country,
                        selectedClient.shipping_pincode,
                      ]
                        .filter(Boolean)
                        .join(", ") || "Not provided"}
                    </p>
                  </div>
                </div>
              </Col>

              {/* Billing Address Card */}
              <Col span={8}>
                <div
                  className={`address-card ${addressType === "billing" ? "selected" : ""
                    }`}
                  onClick={() => {
                    setAddressType("billing");
                    const billingAddress = [
                      selectedClient.billing_address,
                      selectedClient.billing_city,
                      selectedClient.billing_state,
                      selectedClient.billing_country,
                      selectedClient.billing_pincode,
                    ]
                      .filter(Boolean)
                      .join(", ");
                    form.setFieldsValue({
                      shipping_address: billingAddress || "",
                    });
                  }}
                  style={{
                    border:
                      addressType === "billing"
                        ? "2px solid #1890ff"
                        : "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "16px",
                    cursor: "pointer",
                    backgroundColor:
                      addressType === "billing" ? "#f0f8ff" : "#fafafa",
                    transition: "all 0.3s ease",
                    position: "relative",
                    height: "140px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px",
                      justifyContent: "space-between",
                    }}
                  >
                    <h4 style={{ margin: 0, color: "#1890ff" }}>
                      Billing Address
                    </h4>
                    {addressType === "billing" && (
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "#1890ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ color: "white", fontSize: "12px" }}>
                          ✓
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="address-details">
                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                      {[
                        selectedClient.billing_address,
                        selectedClient.billing_city,
                        selectedClient.billing_state,
                        selectedClient.billing_country,
                        selectedClient.billing_pincode,
                      ]
                        .filter(Boolean)
                        .join(", ") || "Not provided"}
                    </p>
                  </div>
                </div>
              </Col>

              {/* Inline Address Input */}
              <Col span={8}>
                <div
                  style={{
                    padding: "16px",
                    backgroundColor: "#f0f8ff",
                    borderRadius: "8px",
                    border: "1px solid #1890ff",
                    height: "140px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h5
                    style={{
                      margin: "0 0 12px 0",
                      color: "#1890ff",
                      fontSize: "14px",
                    }}
                  >
                    Customize{" "}
                    {addressType === "billing" ? "Billing" : "Shipping"}{" "}
                    Address:
                  </h5>
                  <Form.Item
                    name="shipping_address"
                    rules={[{ message: "Please enter the shipping address!" }]}
                    style={{ margin: 0, flex: 1, width: "100%" }}
                  >
                    <Input.TextArea
                      rows={3}
                      placeholder="Enter or customize the address"
                      style={{
                        width: "100%",
                        height: "100%",
                        resize: "none",
                      }}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            {/* </Form.Item> */}
          </div>
        )}

        <Form.Item label="Date" name="date">
          <DatePicker format={"DD/MM/YYYY"} disabled />
        </Form.Item>
        <Form.Item
          label="Delivery Date"
          name="deliver_date"
          rules={[
            {
              required: true,
              message: "Required Field!",
            },
          ]}
        >
          <DatePicker format={"DD/MM/YYYY"} />
        </Form.Item>

        {/* <Form.Item label="Chekbox" name="disabled" valuePropName="checked">
          <Checkbox>Checkbox</Checkbox>
        </Form.Item> */}

        <Form.Item
          label="Job Cordinator"
          name="job_coordinator"
          rules={[
            {
              required: true,
              message: "Required Field!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Assign Digitizer"
          name="assigned_digitizers"
          rules={[{ required: false, message: "Please select a digitizer!" }]}
        >
          <Select
            allowClear
            placeholder="Please select a digitizer"
            loading={digitizersLoading}
            open={autoFocusDigitizer ? digitizerDropdownOpen : undefined}
            onDropdownVisibleChange={(open) => {
              if (autoFocusDigitizer) setDigitizerDropdownOpen(open);
            }}
            ref={digitizerSelectRef}
          >
            {(Array.isArray(digitizers) ? digitizers : digitizers?.results || [])?.map((user) => (
              <Select.Option key={user.id} value={user.id}>
                {user.username} {user.first_name ? `(${user.first_name} ${user.last_name})` : ''}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Quantity"
          name="quantity"
          rules={[{ required: true, message: "Required Field!" }]}
        >
          <InputNumber onChange={(value) => setQ_tity(value)} />
        </Form.Item>

        <Form.Item label="Rate" name="rate">
          <InputNumber />
        </Form.Item>
        <SelectType label="Billing Type" name="billing_type" options={PaymentFieldArray} />

        <SelectType
          label="Style"
          name="style"
          value={getCapName}
          options={selections.style}
        />
        <SelectType label="Size" name="size" options={selections.size} />
        {/* <Form.Item
          label="Artwork"
          name="artwork"
          rules={[
            {
              required: true,
              message: "Required Field!",
            },
          ]}
        >
          <Input />
        </Form.Item> */}

        {colors === null || colors === undefined || colorloading ? (
          <div style={{ paddingTop: "100px" }}>
            {colorloading || manufacture_caploading ? (
              <Skeleton />
            ) : (
              <h2>Please select the cap</h2>
            )}
          </div>
        ) : (
          <>
            <div className="section">
              <div className="title">Style Information</div>

              <div className="sub-section">
                <div className="title">Main Fabric</div>

                {!(false) && (
                  <Row>
                    <Col span={span} offset={offset}>
                      <SelectType
                        label="Front"
                        name="main_fabric_Front_type"
                        // number={number}\\
                        value={getFabric1}
                        options={cloth_type1}
                        required={true}

                      //store data on an api in array format
                      // options={selections.main_fabric_type_array}
                      />
                    </Col>
                    {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}
                    <Col span={span}>
                      {frontcolor !== "pending" && frontcolor !== null ? (
                        <>
                          <p
                            className="cursor-none"
                            onClick={() => setFrontColor("pending")}
                            name="main_fabric_Front_color"
                          >
                            Front Color :<span> {normalizeHexColor(frontcolor) || frontcolor}</span>
                          </p>
                          {/* Technique select for FRONT, appears only after color selected */}
                          <Form.Item name="technique_front" label="Front Technique">
                            <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                          </Form.Item>
                        </>
                      ) : (
                        <>
                          {colorx.loading || frontcolor === null ? (
                            <div className="cursor-none">
                              Please Set The Type
                            </div>
                          ) : (
                            <p>
                              {frontcolor === "pending" ? (
                                <SelectType
                                  label="Front Color"
                                  name="main_fabric_Front_color"
                                  value={getColor1}
                                  //select colors from that array of the object and only show color in the drop box
                                  // options={colorx.users}

                                  options={getColorOptionsWithQty(f1, fronttype, invQtyByColorFront)}
                                  // options={colorx.users.filter((item)=>item.cap_data!==null&&item.cap_data?.quantity!==0).map((c)=>c.color)}
                                  // options={colorx.users.map((colorx) => colorx.color)}
                                  required={true}
                                />
                              ) : (
                                <p className="cursor-none">
                                  Front Color :
                                  <span> {frontcolor}</span>
                                </p>
                              )}
                            </p>
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={qu_span}>
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "baseline",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Quantity : {displayQty(quantity1)}</span>
                        {renderRemainText(remainFront)}
                      </div>
                    </Col>
                  </Row>
                )}
                {a === "BUCKET HAT" ||
                  a === "REVERSIBLE BUCKET HAT" ? (
                  <>
                    {/* Bucket Hat Specific Fields - Using FRONT, TOP, Brim Top, Brim Under, and Cross Band */}
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          label="Brim Top"
                          name="main_fabric_Brim_Top_type"
                          value={getFabric9}
                          options={cloth_type9}
                          required={true}
                        />
                      </Col>
                      <Col span={span}>
                        {brimtopcolor !== "pending" && brimtopcolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setBrimTopColor("pending")}
                            >
                              Brim Top Color :<span> {brimtopcolor}</span>
                            </p>
                            {/* Top technique handled under global Top section to avoid duplicates */}
                          </>
                        ) : (
                          <>
                            {colorx.loading || brimtopcolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {brimtopcolor === "pending" ? (
                                  <SelectType
                                    label="Brim Top Color"
                                    name="main_fabric_Brim_Top_color"
                                    value={getColor9}
                                    options={getColorOptionsWithQty(f9, brimtoptype, invQtyByColorBrimTop)}
                                    required={true}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Brim Top Color :
                                    <span> {brimtopcolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity9)}</span>
                          {renderRemainText(remainBrimTop)}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          label="Brim Under"
                          name="main_fabric_Brim_Under_type"
                          value={getFabric10}
                          options={cloth_type10}
                          required={true}
                        />
                      </Col>
                      <Col span={span}>
                        {brimundercolor !== "pending" && brimundercolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setBrimUnderColor("pending")}
                            >
                              Brim Under Color :<span> {brimundercolor}</span>
                            </p>
                            {/* Under technique retained here for Bucket/Reversible Bucket */}
                            <Form.Item name="technique_under" label="Under Technique">
                              <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            {colorx.loading || brimundercolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {brimundercolor === "pending" ? (
                                  <SelectType
                                    label="Brim Under Color"
                                    name="main_fabric_Brim_Under_color"
                                    value={getColor10}
                                    options={getColorOptionsWithQty(f10, brimundertype, invQtyByColorBrimUnder)}
                                    required={true}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Brim Under Color :
                                    <span> {brimundercolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity10)}</span>
                          {renderRemainText(remainBrimUnder)}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          label="Cross Band"
                          name="main_fabric_Cross_Band_type"
                          value={getFabric13}
                          options={cloth_type13}
                          required={true}
                        />
                      </Col>
                      <Col span={span}>
                        {crossbandcolor !== "pending" && crossbandcolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setCrossBandColor("pending")}
                            >
                              Cross Band Color :<span> {crossbandcolor}</span>
                            </p>
                            {/* Technique select for CROSS BAND */}
                            <Form.Item name="technique_cross_band" label="Cross Band Technique">
                              <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            {colorx.loading || crossbandcolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {crossbandcolor === "pending" ? (
                                  <SelectType
                                    label="Cross Band Color"
                                    name="main_fabric_Cross_Band_color"
                                    value={getColor13}
                                    options={getColorOptionsWithQty(f13, crossbandtype, invQtyByColorCrossBand)}
                                    required={true}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Cross Band Color :
                                    <span> {crossbandcolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity13)}</span>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : a === "UMPIRE HAT" ? (
                  <>
                    {/* Umpire Hat Specific Fields - Using FRONT and TOP */}
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          label="Brim Top"
                          name="main_fabric_Brim_Top_type"
                          value={getFabric9}
                          options={cloth_type9}
                          required={true}
                        />
                      </Col>
                      <Col span={span}>
                        {brimtopcolor !== "pending" && brimtopcolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setBrimTopColor("pending")}
                            >
                              Brim Top Color :<span> {brimtopcolor}</span>
                            </p>
                            {/* Top technique handled under global Top section to avoid duplicates */}
                          </>
                        ) : (
                          <>
                            {colorx.loading || brimtopcolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {brimtopcolor === "pending" ? (
                                  <SelectType
                                    label="Brim Top Color"
                                    name="main_fabric_Brim_Top_color"
                                    value={getColor9}
                                    options={getColorOptionsWithQty(f9, brimtoptype, invQtyByColorBrimTop)}
                                    required={true}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Brim Top Color :
                                    <span> {brimtopcolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity9)}</span>
                          {renderRemainText(remainBrimTop)}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          label="Brim Under"
                          name="main_fabric_Brim_Under_type"
                          value={getFabric10}
                          options={cloth_type10}
                          required={true}
                        />
                      </Col>
                      <Col span={span}>
                        {brimundercolor !== "pending" && brimundercolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setBrimUnderColor("pending")}
                            >
                              Brim Under Color :<span> {brimundercolor}</span>
                            </p>
                            {/* Under technique retained here for Umpire Hat */}
                            <Form.Item name="technique_under" label="Under Technique">
                              <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            {colorx.loading || brimundercolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {brimundercolor === "pending" ? (
                                  <SelectType
                                    label="Brim Under Color"
                                    name="main_fabric_Brim_Under_color"
                                    value={getColor10}
                                    options={getColorOptionsWithQty(f10, brimundertype, invQtyByColorBrimUnder)}
                                    required={true}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Brim Under Color :
                                    <span> {brimundercolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity10)}</span>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          required={true}
                          label="Back"
                          name="main_fabric_Back_type"
                          // number={number}\\
                          value={getFabric2}
                          options={cloth_type2}
                        //store data on an api in array format
                        // options={selections.main_fabric_type_array}
                        />
                      </Col>
                      {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}
                      <Col span={span}>
                        {backcolor !== "pending" && backcolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setbackColor("pending")}
                            >
                              Back Color :<span> {backcolor}</span>
                            </p>
                            {/* Technique select for BACK, appears only after color selected */}
                            <Form.Item name="technique_back" label="Back Technique">
                              <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            {colorx.loading || backcolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {backcolor === "pending" ? (
                                  <SelectType
                                    required={true}
                                    label="Back Color"
                                    name="main_fabric_Back_color"
                                    value={getColor2}
                                    //select colors from that array of the object and only show color in the drop box
                                    options={getColorOptionsWithQty(f2, backtype, invQtyByColorBack)}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Back Color :
                                    <span> {backcolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity2)}</span>
                          {renderRemainText(remainBack)}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={span} offset={offset}>
                        <SelectType
                          required={true}
                          label="Middle"
                          name="main_fabric_Middle_type"
                          // number={number}\\
                          value={getFabric3}
                          options={cloth_type3}

                        //store data on an api in array format
                        // options={selections.main_fabric_type_array}
                        />
                      </Col>
                      {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}
                      <Col span={span}>
                        {middlecolor !== "pending" &&
                          middlecolor !== null ? (
                          <>
                            <p
                              className="cursor-none"
                              onClick={() => setmiddleColor("pending")}
                            >
                              Middle Color :<span> {middlecolor}</span>
                            </p>
                            {/* Technique select for MIDDLE, appears only after color selected */}
                            <Form.Item name="technique_middle" label="Middle Technique">
                              <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                            </Form.Item>
                          </>
                        ) : (
                          <>
                            {colorx.loading || middlecolor === null ? (
                              <div className="cursor-none">
                                Please Set The Type
                              </div>
                            ) : (
                              <p>
                                {middlecolor === "pending" ? (
                                  <SelectType
                                    required={true}
                                    label="Middle Color"
                                    name="main_fabric_Middle_color"
                                    value={getColor3}
                                    //select colors from that array of the object and only show color in the drop box
                                    options={getColorOptionsWithQty(f3, middletype, invQtyByColorMiddle)}
                                  />
                                ) : (
                                  <p className="cursor-none">
                                    Middle Color :
                                    <span> {middlecolor}</span>
                                  </p>
                                )}
                              </p>
                            )}
                          </>
                        )}
                      </Col>
                      <Col span={qu_span}>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                            alignItems: "baseline",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>Quantity : {displayQty(quantity3)}</span>
                          {renderRemainText(remainMiddle)}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}

                {!(false) && (
                  <Row>
                    <Col span={span} offset={offset}>
                      <SelectType
                        required={true}
                        label="Top"
                        name="main_fabric_Top_type"
                        // number={number}\\
                        value={getFabric4}
                        options={cloth_type4}

                      //store data on an api in array format
                      // options={selections.main_fabric_type_array}
                      />
                    </Col>
                    {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}
                    <Col span={span}>
                      {topcolor !== "pending" && topcolor !== null ? (
                        <>
                          <p
                            className="cursor-none"
                            onClick={() => settopColor("pending")}
                          >
                            Top Color :<span> {topcolor}</span>
                          </p>
                          {/* Technique select for TOP, appears only after color selected */}
                          <Form.Item name="technique_top" label="Top Technique">
                            <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                          </Form.Item>
                        </>
                      ) : (
                        <>
                          {colorx.loading || topcolor === null ? (
                            <div className="cursor-none">
                              Please Set The Type
                            </div>
                          ) : (
                            <p>
                              {topcolor === "pending" ? (
                                <SelectType
                                  required={true}
                                  label="Top Color"
                                  name="main_fabric_Top_color"
                                  value={getColor4}
                                  //select colors from that array of the object and only show color in the drop box
                                  options={getColorOptionsWithQty(f4, toptype, invQtyByColorTop)}
                                />
                              ) : (
                                <p className="cursor-none">
                                  Top Color :<span> {topcolor}</span>
                                </p>
                              )}
                            </p>
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={qu_span}>
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "baseline",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Quantity : {displayQty(quantity4)}</span>
                        {renderRemainText(remainTop)}
                      </div>
                    </Col>
                  </Row>
                )}
                {!(a === "BUCKET HAT" || a === "REVERSIBLE BUCKET HAT" || a === "UMPIRE HAT") && (
                  <Row>
                    <Col span={span} offset={offset}>
                      <SelectType
                        required={true}
                        label="Under"
                        name="main_fabric_Under_type"
                        // number={number}\\
                        value={getFabric5}
                        options={cloth_type5}

                      //store data on an api in array format
                      // options={selections.main_fabric_type_array}
                      />
                    </Col>
                    {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}
                    <Col span={span}>
                      {undercolor !== "pending" && undercolor !== null ? (
                        <>
                          <p
                            className="cursor-none"
                            onClick={() => setunderColor("pending")}
                          >
                            Under Color :<span> {undercolor}</span>
                          </p>
                          {/* Technique select for UNDER, appears only after color selected */}
                          <Form.Item name="technique_under" label="Under Technique">
                            <Select placeholder="Select Technique" options={TECHNIQUE_OPTIONS} allowClear />
                          </Form.Item>
                        </>
                      ) : (
                        <>
                          {colorx.loading || undercolor === null ? (
                            <div className="cursor-none">
                              Please Set The Type
                            </div>
                          ) : (
                            <p>
                              {undercolor === "pending" ? (
                                <SelectType
                                  required={true}
                                  label="Under Color"
                                  name="main_fabric_Under_color"
                                  value={getColor5}
                                  //select colors from that array of the object and only show color in the drop box
                                  options={getColorOptionsWithQty(f5, undertype, invQtyByColorUnder)}
                                />
                              ) : (
                                <p className="cursor-none">
                                  Under Color :
                                  <span> {undercolor}</span>
                                </p>
                              )}
                            </p>
                          )}
                        </>
                      )}
                    </Col>
                    <Col span={qu_span}>
                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "baseline",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span>Quantity : {displayQty(quantity5)}</span>
                        {renderRemainText(remainUnder)}
                      </div>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col span={span} offset={offset}>
                    <SelectType
                      //  required={true}

                      label="Piping Type"
                      name="piping_type"
                      // number={number}\\
                      value={getFabric6}
                      options={cloth_type6}

                    //store data on an api in array format
                    // options={selections.main_fabric_type_array}
                    />
                  </Col>
                  {/* //Loading effect because if we dont load the color dropbox the empty 
              array of color is maped and there are no colors 
              in the dropbox */}

                  <Col span={span}>
                    {pipingcolor !== "pending" && pipingcolor !== null ? (
                      <p
                        className="cursor-none"
                        onClick={() => setpipingColor("pending")}
                      >
                        Piping Color :<span> {pipingcolor}</span>
                      </p>
                    ) : (
                      <>
                        {colorx.loading || pipingcolor === null ? (
                          <div className="cursor-none">
                            Please Set The Type
                          </div>
                        ) : (
                          <p>
                            {pipingcolor === "pending" ? (
                              <SelectType
                                // required={true}

                                label="Piping Color"
                                name="piping_color"
                                value={getColor6}
                                options={piping_color_options}
                              />
                            ) : (
                              <p className="cursor-none">
                                Piping Color :
                                <span> {pipingcolor}</span>
                              </p>
                            )}
                          </p>
                        )}
                      </>
                    )}
                  </Col>
                  <Col span={qu_span}>Quantity : {quantity6}</Col>
                </Row>
              </div>
              {/* 1. Fusing - available for all cap types */}
              <SelectType
                label="Fusing"
                name="fusing"
                // options={selections.fusing_array}
                options={fusing_options}
                value={(data) => objfun(fusing_type, data)}
              />

              {/* 2. Taper */}
              {a === "MANUAL" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ? (
                <SelectType
                  label="Taper"
                  name="tapper"
                  options={taper_options}
                  value={(data) => objfun(taper, data)}
                // options={tyeps}
                />
              ) : null}

              {/* 3. Cap Button */}
              {a === "MANUAL" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ? (
                <SelectType
                  label="Cap Button"
                  name="cap_button"
                  options={capButtonOptions}
                  value={(selectedType) => {
                    const items = Array.isArray(invCapButtonList)
                      ? invCapButtonList
                      : invCapButtonList?.results || [];
                    const match = items.find((it) => it?.color_cloth?.type === selectedType);
                    if (match?.color_cloth?.id) {
                      setButton_obj({ cloth_id: match.color_cloth.id });
                    }
                  }}
                />
              ) : null}

              {/* 4. Button Color */}
              {a === "MANUAL" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ? (
                <SelectType
                  label="Button Color"
                  name="button"
                  options={buttonColorOptions}
                  value={(data) => objfun("BUTTON", data)}
                />
              ) : null}

              {/* 5. Visor Type */}
              {a === "UMPIRE HAT" ? null : (
                <SelectType
                  label="Visior Type"
                  name="visior_type"
                  // options={selections.visor_type_array}
                  options={visor_type_options}
                  value={(data) => objfun(visor_type, data)}
                />
              )}

              {/* 6. Visor Stitch */}
              <SelectType
                label="Visor Stitch"
                name="visor_stitch"
                options={selections.visor_stitch_array}
              />

              {/* 7. Foam - removed from create UI */}
              {/*
              {a === "DAD HAT 6 PART HIP HOP CAP" ||
              a === "6 PART BASE BALL CAP" ||
              a === "5 PART HIP HOP CAP" ||
              a === "6 PART HIP HOP CAP" ||
              a === "MANUAL" ||
              a === "BUCKET HAT" ||
              a === "REVERSIBLE BUCKET HAT" ||
              a === "UMPIRE HAT" ? (
                <SelectType
                  label="Foam"
                  name="foam"
                  // options={selections.fusing_array}
                  options={foam_data}
                  value={(data) => objfun(foam_type, data)}
                />
              ) : null}
              */}

              {/* 8. Buckle - removed from create UI */}
              {/*
              {a === "MANUAL" ||
              a === "5 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART BASE BALL CAP" ||
              a === "DAD HAT 6 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART HIP HOP CAP" ||
              a === "DAD HAT 6 PART HIP HOP CAP" ||
              a === "6 PART BASE BALL CAP" ||
              a === "5 PART HIP HOP CAP" ||
              a === "6 PART HIP HOP CAP" ? (
                <SelectType
                  label="Buckle"
                  name="buckle"
                  // options={selections.fusing_array}
                  options={buckle_data}
                  value={(data) => objfun(buckel_init, data)}
                />
              ) : null}
              */}

              {/* 9. Buckle Belt - removed from create UI */}
              {/*
              {a === "MANUAL" ||
              a === "5 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART BASE BALL CAP" ||
              a === "DAD HAT 6 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART HIP HOP CAP" ||
              a === "DAD HAT 6 PART HIP HOP CAP" ||
              a === "6 PART BASE BALL CAP" ||
              a === "5 PART HIP HOP CAP" ||
              a === "6 PART HIP HOP CAP" ? (
                <SelectType
                  label="Buckle Belt"
                  name="buckle_belt"
                  // options={selections.fusing_array}
                  options={buckle_belt_data}
                  value={(data) => objfun(buckle_belt_init, data)}
                />
              ) : null}
              */}

              {/* 10. Nonon - removed from create UI */}
              {/*
              {a === "MANUAL" ||
              a === "5 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART BASE BALL CAP" ||
              a === "DAD HAT 6 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART HIP HOP CAP" ||
              a === "DAD HAT 6 PART HIP HOP CAP" ||
              a === "6 PART BASE BALL CAP" ||
              a === "5 PART HIP HOP CAP" ||
              a === "6 PART HIP HOP CAP" ? (
                <SelectType
                  label="Nonon"
                  name="nonon"
                  // options={selections.fusing_array}
                  options={nonon_data}
                  value={(data) => objfun(nonon_type, data)}
                />
              ) : null}
              */}

              {/* 11. Binder - removed from create UI */}
              {/*
              {a === "MANUAL" ||
              a === "5 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART BASE BALL CAP" ||
              a === "DAD HAT 6 PART BASE BALL CAP" ||
              a === "DAD HAT 5 PART HIP HOP CAP" ||
              a === "DAD HAT 6 PART HIP HOP CAP" ||
              a === "6 PART BASE BALL CAP" ||
              a === "5 PART HIP HOP CAP" ||
              a === "6 PART HIP HOP CAP" ? (
                <SelectType
                  label="Binder"
                  name="binder"
                  options={binder_data}
                  value={(data) => objfun(BINDER, data)}
                />
              ) : null}
              */}

              {/* 12. SIZING STRIP */}
              {a === "MANUAL" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ? (
                <SelectType
                  label="SIZING STRIP"
                  name="sizing_strip"
                  options={sizing_strip_options}
                  value={(data) => objfun(STRIP, data)}
                />
              ) : null}

              {/* BRIM FOAM - kept in original position */}
              {a === "UMPIRE HAT" ? (
                <SelectType
                  label="BRIM FOAM"
                  name="brim_foam"
                  // options={selections.visor_type_array}
                  options={brim_foam_data}
                  value={(data) => objfun(brim_foam_init, data)}
                />
              ) : null}

              <div className="sub-section">
                <div className="title">Sweatband</div>

                <SelectType
                  label="Type"
                  name="sweate_band_type"
                  options={sweat_band_options}
                  value={(data) => objfun(sweatsss, data)}
                />
              </div>
              {a === "SUN CAP ONE" ||
                a === "SUN CAP TWO" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ||
                a === "MANUAL" ? (
                <>
                  <div className="sub-section">
                    <div className="title">Back Closer</div>
                    <SelectType
                      label="Type"
                      name="back_close_type"
                      // options={selections.back_closer_type}
                      options={back_closer_data}
                      value={getCloser}
                    />
                    <SelectType
                      label="Color"
                      name="back_closer_color"
                      options={back_closer_colors}
                      value={getCloser_color}
                    />
                    {/* Snappack - removed from Back Closer UI */}
                    {/*
                    <SelectType
                      label="Snappack"
                      name="snapack"
                      options={snappack_data}
                      value={(data) => objfun(snap_pack_init, data)}
                    />
                    */}
                  </div>{" "}
                </>
              ) : null}

              {/* O-Ring - removed from create UI */}
              {/*
              <SelectType
                label="O-Ring"
                name="o_ring"
                options={o_ring_data}
                value={(data) => objfun(o_ring_init, data)}
              />
              */}

              {/* Sweat Band Holding - removed from create UI */}
              {/*
              <SelectType
                label="Sweat Band Holding"
                name="sweat_band_holding"
                options={sweat_band_holding_data}
                value={(data) => objfun(sweat_band_holding_init, data)}
              />
              */}

              {a === "BAGGY CAP" ||
                a === "DEVANAND CAP" ||
                a === "5 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART BASE BALL CAP" ||
                a === "DAD HAT 6 PART BASE BALL CAP" ||
                a === "DAD HAT 5 PART HIP HOP CAP" ||
                a === "DAD HAT 6 PART HIP HOP CAP" ||
                a === "6 PART BASE BALL CAP" ||
                a === "5 PART HIP HOP CAP" ||
                a === "6 PART HIP HOP CAP" ||
                a === "5 Part Rounded" ||
                a === "5 Part Pointed" ||
                a === "MANUAL" ? (
                <>
                  <div className="sub-section">
                    <div className="title">Elastic</div>

                    <SelectType
                      label="Elastic"
                      name="elastic"
                      options={elastic_color_options}
                      value={(data) => objfun(elastic_init, data)}
                    />
                    <SelectType
                      label="Interlining"
                      name="interlining"
                      options={interlining_color_options}
                      value={(data) => objfun(interlining_init, data)}
                    />

                    {a === "DEVANAND CAP" ? null : (
                      <SelectType
                        label="Full Elastic"
                        name="full_closure_elastic"
                        options={full_elastic_color_options}
                        value={(data) => objfun(full_closer_init, data)}
                      />
                    )}
                  </div>
                </>
              ) : null}
            </div>
            {/* Other Materials - removed from create UI */}
            {/*
            <div className="sub-section">
              <div className="title">Other Materials</div>

              <SelectType
                label="Carton"
                name="carton"
                options={carton_data}
                value={(data) => fun_for_type(carton_init, data)}
              />
              <SelectType
                label="Plastic Bag"
                name="plastic_bag"
                options={plastic_bag_data}
                value={(data) => fun_for_type(plastic_init, data)}
              />
            </div>
            */}

            <div className="sub-section">
              <div className="title">Eyelet</div>

              <SelectType
                label="Front"
                name="eyelet_front"
                options={selections.eyelet_front_array}
              />
              <Form.Item noStyle shouldUpdate={(prev, curr) => prev.eyelet_front !== curr.eyelet_front}>
                {(formCtx) => {
                  const val = formCtx.getFieldValue('eyelet_front');
                  const label = typeof val === 'object' ? (val?.label || val?.value || '') : String(val || '');
                  const show = String(label).toUpperCase().includes('COLOR');

                  // Clear color value if eyelet option doesn't include "COLOR"
                  if (!show && formCtx.getFieldValue('eyelet_front_color_sel')) {
                    formCtx.setFieldsValue({ eyelet_front_color_sel: undefined });
                  }

                  return show ? (
                    <Form.Item name="eyelet_front_color_sel" label="Select Color">
                      <Select
                        showSearch
                        allowClear
                        optionLabelProp="label"
                        filterOption={(input, option) => {
                          const lbl = (option?.label ?? '').toLowerCase();
                          const colorName = extractColorName(option?.label ?? '').toLowerCase();
                          const query = input.toLowerCase();
                          return lbl.includes(query) || colorName.includes(query);
                        }}
                      >
                        {uniqueEyeletColors?.map((it) => {
                          const label = it.color;
                          const value = it.id ?? it.color;
                          const hexColor = getColorHex({ color_code: it.color_code, color: it.color });
                          const isWhite = hexColor && (hexColor.toLowerCase() === '#ffffff' || hexColor.toLowerCase() === '#fff');
                          return (
                            <Select.Option key={value} value={value} label={label}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{
                                  width: 16,
                                  height: 16,
                                  backgroundColor: hexColor || '#f0f0f0',
                                  border: isWhite ? '1px solid #d9d9d9' : 'none',
                                  borderRadius: 4,
                                  display: 'inline-block'
                                }} />
                                <span>{label}</span>
                              </div>
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
              <SelectType
                label="Back"
                name="eyelet_back"
                options={selections.eyelet_back_array}
              />
              <Form.Item noStyle shouldUpdate={(prev, curr) => prev.eyelet_back !== curr.eyelet_back}>
                {(formCtx) => {
                  const val = formCtx.getFieldValue('eyelet_back');
                  const label = typeof val === 'object' ? (val?.label || val?.value || '') : String(val || '');
                  const show = String(label).toUpperCase().includes('COLOR');

                  // Clear color value if eyelet option doesn't include "COLOR"
                  if (!show && formCtx.getFieldValue('eyelet_back_color_sel')) {
                    formCtx.setFieldsValue({ eyelet_back_color_sel: undefined });
                  }

                  return show ? (
                    <Form.Item name="eyelet_back_color_sel" label="Select Color">
                      <Select
                        showSearch
                        allowClear
                        optionLabelProp="label"
                        filterOption={(input, option) => {
                          const lbl = (option?.label ?? '').toLowerCase();
                          const colorName = extractColorName(option?.label ?? '').toLowerCase();
                          const query = input.toLowerCase();
                          return lbl.includes(query) || colorName.includes(query);
                        }}
                      >
                        {uniqueEyeletColors?.map((it) => {
                          const label = it.color;
                          const value = it.id ?? it.color;
                          const hexColor = getColorHex({ color_code: it.color_code, color: it.color });
                          const isWhite = hexColor && (hexColor.toLowerCase() === '#ffffff' || hexColor.toLowerCase() === '#fff');
                          return (
                            <Select.Option key={value} value={value} label={label}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{
                                  width: 16,
                                  height: 16,
                                  backgroundColor: hexColor || '#f0f0f0',
                                  border: isWhite ? '1px solid #d9d9d9' : 'none',
                                  borderRadius: 4,
                                  display: 'inline-block'
                                }} />
                                <span>{label}</span>
                              </div>
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
              {console.log("selections", selections)}

              <SelectType
                label="Middles"
                name="eyelet_middle"
                options={selections.eyelet_middle_array}
              />
              <Form.Item noStyle shouldUpdate={(prev, curr) => prev.eyelet_middle !== curr.eyelet_middle}>
                {(formCtx) => {
                  const val = formCtx.getFieldValue('eyelet_middle');
                  const label = typeof val === 'object' ? (val?.label || val?.value || '') : String(val || '');
                  const show = String(label).toUpperCase().includes('COLOR');

                  // Clear color value if eyelet option doesn't include "COLOR"
                  if (!show && formCtx.getFieldValue('eyelet_middle_color_sel')) {
                    formCtx.setFieldsValue({ eyelet_middle_color_sel: undefined });
                  }

                  return show ? (
                    <Form.Item name="eyelet_middle_color_sel" label="Select Color">
                      <Select
                        showSearch
                        allowClear
                        optionLabelProp="label"
                        filterOption={(input, option) => {
                          const lbl = (option?.label ?? '').toLowerCase();
                          const colorName = extractColorName(option?.label ?? '').toLowerCase();
                          const query = input.toLowerCase();
                          return lbl.includes(query) || colorName.includes(query);
                        }}
                      >
                        {uniqueEyeletColors?.map((it) => {
                          const label = it.color;
                          const value = it.id ?? it.color;
                          const hexColor = getColorHex({ color_code: it.color_code, color: it.color });
                          const isWhite = hexColor && (hexColor.toLowerCase() === '#ffffff' || hexColor.toLowerCase() === '#fff');
                          return (
                            <Select.Option key={value} value={value} label={label}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{
                                  width: 16,
                                  height: 16,
                                  backgroundColor: hexColor || '#f0f0f0',
                                  border: isWhite ? '1px solid #d9d9d9' : 'none',
                                  borderRadius: 4,
                                  display: 'inline-block'
                                }} />
                                <span>{label}</span>
                              </div>
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : null;
                }}
              </Form.Item>
            </div>
          </>
        )}
        <div className="section">
          <div className="title">Embroidary Placement</div>
          <Row>
            <Col span={10} offset={2}>
              <Form.Item label="Front" name="embr_Front">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Back" name="embr_Back">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10} offset={2}>
              <Form.Item label="Left Middle" name="embr_Left_Middle">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Right Middle" name="embr_Right_Middle">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10} offset={2}>
              <Form.Item label="Visor" name="embr_Visor">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="Velcro" name="embr_Velcro">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10} offset={2}>
              <Form.Item label="Visor Square" name="embr_Visor_Square">
                <Input />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="One Side Emb" name="embr_One_Side_Emb">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Form.Item label="Special Instructions" name="special_instructions">
          <Input />
        </Form.Item>
        <Form.Item
          name={"img1"}
          label="Jobcard Image"
          valuePropName="fileList"
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 12 }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
              <div
                style={{
                  position: "relative",
                  width: "200px",
                  height: "200px",
                  border: "2px dashed #d9d9d9",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: "#fafafa",
                  transition: "border-color 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#1890ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#d9d9d9";
                }}
              >
                {img1Preview || (formValues && formValues?.img1 && !shouldDeleteImg1) ? (
                  <div style={{ position: "relative", width: "100%", height: "100%" }}>
                    <img
                      src={img1Preview || (formValues?.img1 && !shouldDeleteImg1 ? formValues?.img1 : null)}
                      alt="Selected Image"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        borderRadius: "6px",
                      }}
                    />
                    <Button
                      type="primary"
                      danger
                      shape="circle"
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleImg1Remove();
                      }}
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        backgroundColor: "rgba(255, 77, 79, 0.9)",
                        border: "none",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      }}
                    />
                  </div>
                ) : (
                  <>
                    <InboxOutlined
                      style={{
                        fontSize: "48px",
                        color: "#1890ff",
                        marginBottom: "8px",
                      }}
                    />
                    <div style={{ marginBottom: "8px", fontWeight: 500, color: "#595959" }}>
                      Jobcard Image
                    </div>
                    <div style={{ color: "#8c8c8c", fontSize: "12px" }}>
                      Click or drag to upload
                    </div>
                    <input
                      key={img1InputKey}
                      type="file"
                      accept="image/*"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                      }}
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          handleImg1Change(file);
                        }
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            {(img1Preview || (formValues && formValues?.img1 && !shouldDeleteImg1)) && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "400px" }}>
                <label style={{ fontSize: "14px", fontWeight: 500, color: "#595959" }}>
                  Image Name:
                </label>
                <Input
                  value={img1ImageName}
                  onChange={(e) => setImg1ImageName(e.target.value)}
                  placeholder="Enter image name"
                  style={{ width: "100%" }}
                />
              </div>
            )}
          </div>
        </Form.Item>

        {/* <Form.Item label="Images" valuePropName="fileList">
          <Upload beforeUpload={(e) => } listType="picture-card">
            <div>
              <PlusOutlined />
              <div
                style={{
                  marginTop: 8,
                }}
              >
                Images
              </div>
            </div>
          </Upload>
        </Form.Item> */}
        <>
          <Space
            style={{
              margin: "auto",
              width: "100vw",
              // background: "red",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {formValues && formValues?.img1 && !shouldDeleteImg1 && (
              <>
                <h4>Previously Selected Img 1</h4>
                <ImageViewer
                  style={{ height: "100px", width: "100px" }}
                  src={formValues?.img1}
                />
              </>
            )}
          </Space>
        </>
        {/* <Form.Item name={"img2"} valuePropName="fileList" label="Image 2">
          <input type={"file"} />
        </Form.Item>
        <Form.Item name={"img3"} valuePropName="fileList" label="Image 3">
          <input type={"file"} />
        </Form.Item>
        <Form.Item name={"img4"} valuePropName="fileList" label="Image 4">
          <input type={"file"} />
        </Form.Item> */}
        {/* <Form.Item
          name={"front_image"}
          valuePropName="fileList"
          label="Front Image"
        >
          <input type={"file"} />
        </Form.Item>
        <Form.Item
          name={"right_image"}
          valuePropName="fileList"
          label="Right Image"
        >
          <input type={"file"} />
        </Form.Item>
        <Form.Item
          name={"left_image"}
          valuePropName="fileList"
          label="Left Image"
        >
          <input type={"file"} />
        </Form.Item>
        <Form.Item
          name={"back_image"}
          valuePropName="fileList"
          label="Back Image"
        >
          <input type={"file"} />
        </Form.Item>
        <Form.Item
          name={"color_image"}
          valuePropName="fileList"
          label="Color Image"
        >
          <input type={"file"} />
        </Form.Item> */}

        {/* Digitizers Images Upload Section */}
        {!formValues && (
          <>
            <Divider orientation="left">digitizers images</Divider>

            <div style={{ marginBottom: "16px", border: "1px solid #d9d9d9", borderRadius: "8px", padding: "16px", backgroundColor: "#fafafa" }}>
              <Row gutter={[16, 16]} style={{ fontWeight: "bold", borderBottom: "1px solid #d9d9d9", paddingBottom: "8px", marginBottom: "8px" }}>
                <Col span={6}>Embroidery Placement</Col>
                <Col span={9}>Images</Col>
                <Col span={9}>Embroidery Images (.emb)</Col>
              </Row>
              {["Front", "Right Middle", "Left Middle", "Back", "Velcro", "Visor"].map((side) => (
                <Row gutter={[16, 16]} key={side} style={{ alignItems: "center", borderBottom: "1px solid #f0f0f0", padding: "12px 0" }}>
                  <Col span={6} style={{ fontWeight: 500 }}>
                    <div style={{ fontSize: "16px" }}>{side}</div>
                  </Col>

                  {/* Designer Image Upload Column */}
                  <Col span={9}>
                    <div
                      style={{
                        border: "2px dashed #d9d9d9",
                        borderRadius: "8px",
                        padding: "8px",
                        textAlign: "center",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        position: "relative",
                        minHeight: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onMouseEnter={(e) => {
                        if (!capSideImages[side]) {
                          e.currentTarget.style.borderColor = "#1890ff";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!capSideImages[side]) {
                          e.currentTarget.style.borderColor = "#d9d9d9";
                        }
                      }}
                    >
                      {imagePreviews[side] ? (
                        <div style={{ position: "relative", width: "100%" }}>
                          {renderFilePreview(imagePreviews[side], capSideImages[side], "80px")}
                          <Button
                            type="link"
                            danger
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleImageRemove(side);
                            }}
                            style={{
                              position: "absolute",
                              top: "-4px",
                              right: "-4px",
                              backgroundColor: "rgba(255, 255, 255, 0.9)",
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      ) : (
                        <>
                          <div>
                            <InboxOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
                            <div style={{ color: "#8c8c8c", fontSize: "12px", marginTop: "4px" }}>Click/drag to upload image</div>
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) handleImageChange(side, file);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </Col>

                  {/* .emb File Upload Column */}
                  <Col span={9}>
                    <div
                      style={{
                        border: "2px dashed #d9d9d9",
                        borderRadius: "8px",
                        padding: "8px",
                        textAlign: "center",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        position: "relative",
                        minHeight: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onMouseEnter={(e) => {
                        if (!embroiderySideImages[side]) {
                          e.currentTarget.style.borderColor = "#52c41a";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!embroiderySideImages[side]) {
                          e.currentTarget.style.borderColor = "#d9d9d9";
                        }
                      }}
                    >
                      {embroiderySideImages[side] ? (
                        <div style={{ position: "relative", width: "100%" }}>
                          <FilePdfOutlined style={{ fontSize: "32px", color: "#ff4d4f" }} />
                          <div style={{ fontSize: "12px", marginTop: "4px", wordBreak: "break-all" }}>
                            {embroiderySideImages[side].name}
                          </div>
                          <Button
                            type="link"
                            danger
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEmbroideryImageRemove(side);
                            }}
                            style={{
                              position: "absolute",
                              top: "-4px",
                              right: "-4px",
                              backgroundColor: "rgba(255, 255, 255, 0.9)",
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      ) : (
                        <>
                          <div>
                            <InboxOutlined style={{ fontSize: "24px", color: "#52c41a" }} />
                            <div style={{ color: "#8c8c8c", fontSize: "12px", marginTop: "4px" }}>Click/drag to upload .emb</div>
                          </div>
                          <input
                            type="file"
                            accept=".emb"
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) handleEmbroideryImageChange(side, file);
                            }}
                          />
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              ))}
            </div>
            <Divider />

          </>
        )}

        {/* Digitizers Images Edit Section for Update Mode */}
        {formValues && (
          <>
            <Divider orientation="left">
              digitizers images
              {isDigitizerWorkDone && (
                <span style={{ marginLeft: "12px", fontSize: "14px", color: "#8c8c8c", fontWeight: "normal" }}>
                  (Read-only: Digitizer work completed)
                </span>
              )}
            </Divider>

            {/* Digitizer stage: show designer reference + separate digitizer upload slots */}
            {(formValues?.is_degitizer_stage === true || formValues?.is_degitizer_stage === "true") ? (
              <Row gutter={[16, 16]}>
                {["Front", "Right Middle", "Left Middle", "Back", "Velcro", "Visor"].map((side) => {
                  const designerRef = existingImages[side];
                  const existingDigitizer = existingDigitizerImages[side];
                  const hasNewImage = capSideImages[side] || imagePreviews[side];

                  return (
                    <Col span={8} key={side}>
                      {/* Designer reference thumbnail (read-only) */}
                      {designerRef && (
                        <div style={{ marginBottom: "8px", border: "1px solid #e8e8e8", borderRadius: "4px", padding: "4px" }}>
                          <div style={{ fontSize: "11px", color: "#8c8c8c", marginBottom: "4px" }}>Designer Ref</div>
                          {renderExistingFile(designerRef.url, `${side} designer ref`, "80px")}
                        </div>
                      )}

                      {/* Digitizer upload slot */}
                      <div
                        style={{
                          border: "2px dashed #d9d9d9",
                          borderRadius: "8px",
                          padding: "16px",
                          textAlign: "center",
                          backgroundColor: isDigitizerWorkDone ? "#f5f5f5" : "#fafafa",
                          cursor: isDigitizerWorkDone ? "not-allowed" : "pointer",
                          transition: "all 0.3s",
                          position: "relative",
                          opacity: isDigitizerWorkDone ? 0.8 : 1,
                        }}
                        onMouseEnter={(e) => {
                          if (!isDigitizerWorkDone && !hasNewImage && !existingDigitizer) {
                            e.currentTarget.style.borderColor = "#1890ff";
                            e.currentTarget.style.backgroundColor = "#f0f8ff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isDigitizerWorkDone && !hasNewImage && !existingDigitizer) {
                            e.currentTarget.style.borderColor = "#d9d9d9";
                            e.currentTarget.style.backgroundColor = "#fafafa";
                          }
                        }}
                      >
                        {imagePreviews[side] ? (
                          <div style={{ position: "relative" }}>
                            {renderFilePreview(imagePreviews[side], capSideImages[side], "150px")}
                            {!isDigitizerWorkDone && (
                              <Button
                                type="link"
                                danger
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleImageRemove(side); }}
                                style={{ position: "absolute", top: "4px", right: "4px", backgroundColor: "rgba(255,255,255,0.8)" }}
                              >
                                Remove
                              </Button>
                            )}
                          </div>
                        ) : existingDigitizer ? (
                          <div style={{ position: "relative" }}>
                            {renderExistingFile(existingDigitizer.url, side, "150px")}
                            {existingDigitizer.image?.created_at && (
                              <div style={{ position: "absolute", top: "4px", right: "4px", background: "rgba(0,0,0,0.6)", color: "#fff", fontSize: 9, padding: "2px 6px", borderRadius: 4, zIndex: 3, fontWeight: 400, whiteSpace: "nowrap" }}>
                                {formatImageCreatedAt(existingDigitizer.image.created_at)}
                              </div>
                            )}
                            {!isDigitizerWorkDone && (
                              <Button
                                type="link"
                                danger
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteExistingImage(side);
                                }}
                                style={{ position: "absolute", top: existingDigitizer.image?.created_at ? "28px" : "4px", right: "4px", backgroundColor: "rgba(255,255,255,0.8)", zIndex: 3 }}
                              >
                                Remove
                              </Button>
                            )}
                          </div>
                        ) : (
                          <>
                            <InboxOutlined style={{ fontSize: "40px", color: isDigitizerWorkDone ? "#d9d9d9" : "#1890ff", marginBottom: "8px" }} />
                            <div style={{ marginBottom: "8px", fontWeight: 500 }}>{side}</div>
                            <div style={{ color: "#8c8c8c", fontSize: "12px" }}>
                              {isDigitizerWorkDone ? "Digitizer work completed" : "Upload digitizer image"}
                            </div>
                          </>
                        )}
                        {!isDigitizerWorkDone && !imagePreviews[side] && (
                          <input
                            type="file"
                            accept="image/*,application/pdf"
                            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (file) handleImageChange(side, file);
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            ) : (
              /* Normal edit mode (not digitizer stage) — unchanged behaviour */
              <Row gutter={[16, 16]}>
                {["Front", "Right Middle", "Left Middle", "Back", "Velcro", "Visor"].map((side) => {
                  const existingImage = existingImages[side];
                  const hasNewImage = capSideImages[side] || imagePreviews[side];

                  return (
                    <Col span={8} key={side}>
                      <div
                        style={{
                          border: "2px dashed #d9d9d9",
                          borderRadius: "8px",
                          padding: "16px",
                          textAlign: "center",
                          backgroundColor: isDigitizerWorkDone ? "#f5f5f5" : "#fafafa",
                          cursor: isDigitizerWorkDone ? "not-allowed" : "pointer",
                          transition: "all 0.3s",
                          position: "relative",
                          opacity: isDigitizerWorkDone ? 0.8 : 1,
                        }}
                        onMouseEnter={(e) => {
                          if (!isDigitizerWorkDone && !hasNewImage && !existingImage) {
                            e.currentTarget.style.borderColor = "#1890ff";
                            e.currentTarget.style.backgroundColor = "#f0f8ff";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isDigitizerWorkDone && !hasNewImage && !existingImage) {
                            e.currentTarget.style.borderColor = "#d9d9d9";
                            e.currentTarget.style.backgroundColor = "#fafafa";
                          }
                        }}
                      >
                        {/* Show new image preview if uploaded (takes priority) */}
                        {imagePreviews[side] ? (
                          <div style={{ position: "relative" }}>
                            {renderFilePreview(imagePreviews[side], capSideImages[side])}
                            {!isDigitizerWorkDone && (
                              <Button
                                type="link"
                                danger
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleImageRemove(side); }}
                                style={{ position: "absolute", top: "4px", right: "4px", backgroundColor: "rgba(255, 255, 255, 0.8)" }}
                              >
                                Remove
                              </Button>
                            )}
                          </div>
                        ) : existingImage ? (
                          <div style={{ position: "relative" }}>
                            {renderExistingFile(existingImage.url, side)}
                            {existingImage.image?.created_at && (
                              <div style={{ position: "absolute", top: "4px", right: "4px", background: "rgba(0,0,0,0.6)", color: "#fff", fontSize: 9, padding: "2px 6px", borderRadius: 4, zIndex: 3, fontWeight: 400, whiteSpace: "nowrap" }}>
                                {formatImageCreatedAt(existingImage.image.created_at)}
                              </div>
                            )}
                            {!isDigitizerWorkDone && (
                              <Button
                                type="link"
                                danger
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDeleteExistingImage(side); }}
                                style={{ position: "absolute", top: existingImage.image?.created_at ? "28px" : "4px", right: "4px", backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 3 }}
                              >
                                Remove
                              </Button>
                            )}
                          </div>
                        ) : (
                          <>
                            <InboxOutlined style={{ fontSize: "48px", color: isDigitizerWorkDone ? "#d9d9d9" : "#1890ff", marginBottom: "8px" }} />
                            <div style={{ marginBottom: "8px", fontWeight: 500 }}>{side}</div>
                            <div style={{ color: "#8c8c8c", fontSize: "12px" }}>
                              {isDigitizerWorkDone ? "Digitizer work completed - editing disabled" : "Click or drag to upload"}
                            </div>
                            {!isDigitizerWorkDone && (
                              <input
                                type="file"
                                accept="image/*"
                                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "pointer" }}
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file) handleImageChange(side, file);
                                }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
            <Divider />
          </>
        )}

        <Form.Item
          name={"main_image"}
          label="Digitizers Main Image"
          valuePropName="fileList"
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 12 }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
            <div
              style={{
                position: "relative",
                width: "200px",
                height: "200px",
                border: "2px dashed #d9d9d9",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "#fafafa",
                transition: "border-color 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#1890ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#d9d9d9";
              }}
            >
              {mainImagePreview || (formValues && formValues?.main_image && !shouldDeleteMainImage) ? (
                <div style={{ position: "relative", width: "100%", height: "100%" }}>
                  <img
                    src={mainImagePreview || (formValues?.main_image && !shouldDeleteMainImage ? formValues?.main_image : null)}
                    alt="Main Image"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "6px",
                    }}
                  />
                  <Button
                    type="primary"
                    danger
                    shape="circle"
                    icon={<DeleteOutlined />}
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMainImageRemove();
                    }}
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      backgroundColor: "rgba(255, 77, 79, 0.9)",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
              ) : (
                <>
                  <InboxOutlined
                    style={{
                      fontSize: "48px",
                      color: "#1890ff",
                      marginBottom: "8px",
                    }}
                  />
                  <div style={{ marginBottom: "8px", fontWeight: 500, color: "#595959" }}>
                    Jobcard Main Image
                  </div>
                  <div style={{ color: "#8c8c8c", fontSize: "12px" }}>
                    Click or drag to upload
                  </div>
                  <input
                    key={mainImageInputKey}
                    type="file"
                    accept="image/*"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                    }}
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        handleMainImageChange(file);
                      }
                    }}
                  />
                </>
              )}
            </div>
            {formValues && formValues?.main_image && !mainImagePreview && !shouldDeleteMainImage && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "12px", color: "#8c8c8c" }}>Current Main Image</span>
                <ImageViewer
                  style={{ height: "100px", width: "100px", border: "1px solid #d9d9d9", borderRadius: "4px" }}
                  src={formValues?.main_image}
                />
              </div>
            )}
          </div>
        </Form.Item>

        <Form.Item style={{ width: "100%" }}>
          <div
            className="button-row"
            onClickCapture={handleSpaceClick}
            style={{ display: "flex", alignItems: "center", width: "100%", gap: "12px" }}
          >
            {/* Left group: Update + Duplicate */}
            <div style={{ display: "flex", alignItems: "center", gap: "40px" }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                disabled={isCreationInProgress}
                loading={isCreationInProgress}
              >
                {formValues ? "Update Jobcard" : "Create Job Card"}
              </Button>
              {formValues && (
                <Button
                  type="default"
                  size="large"
                  disabled={isCreationInProgress}
                  onClick={async () => {
                    // Prevent duplication if creation is in progress
                    if (isCreationInProgress) {
                      message.warning("Please wait for the current creation to complete.");
                      return;
                    }
                    const values = form.getFieldsValue();
                    values.main_fabric_Front_color = frontcolor;
                    values.main_fabric_Back_color = backcolor;
                    values.main_fabric_Middle_color = middlecolor;
                    values.main_fabric_Top_color = topcolor;
                    values.main_fabric_Under_color = undercolor;
                    values.piping_color = pipingcolor;
                    delete values.id;

                    const formatedValues = {
                      ...values,
                      date: values.date?.format("YYYY-MM-DD") || "",
                      deliver_date: values.deliver_date?.format("YYYY-MM-DD") || "",
                      current_stage: STAGES.CREATION,
                    };

                    const imageFields = [
                      "img1",
                      "main_image",
                      "img2",
                      "img3",
                      "img4",
                      "left_image",
                      "right_image",
                      "front_image",
                      "color_image",
                      "back_image",
                    ];

                    for (const field of imageFields) {
                      if (values[field]?.target?.files?.[0]) {
                        formatedValues[field] = values[field].target.files[0];
                      } else if (formValues[field]) {
                        const filename = formValues[field].split("/").pop();
                        const file = await urlToFile(formValues[field], filename);
                        if (file) {
                          formatedValues[field] = file;
                        } else {
                          delete formatedValues[field];
                        }
                      } else {
                        delete formatedValues[field];
                      }
                    }

                    // Copy embroidery side flags from original jobcard first
                    const embroideryFlags = [
                      "is_front",
                      "is_right_middle",
                      "is_left_middle",
                      "is_back",
                      "is_velcro",
                      "is_visor",
                    ];

                    // Copy flags from original jobcard
                    embroideryFlags.forEach((flag) => {
                      if (formValues && formValues[flag] !== undefined) {
                        formatedValues[flag] = formValues[flag];
                      }
                    });

                    // Copy technique_map from original jobcard (includes Under Technique and all other techniques)
                    if (formValues && formValues.techniques) {
                      formatedValues.technique_map = formValues.techniques;
                      // Also copy individual technique fields so they appear in the form fields
                      const techniquesMap = formValues.techniques;
                      formatedValues.technique_front = techniquesMap?.front ?? undefined;
                      formatedValues.technique_back = techniquesMap?.back ?? undefined;
                      formatedValues.technique_middle = techniquesMap?.middle ?? undefined;
                      formatedValues.technique_top = techniquesMap?.top ?? undefined;
                      formatedValues.technique_under = techniquesMap?.under ?? undefined;
                      formatedValues.technique_cross_band = techniquesMap?.cross_band ?? undefined;
                    }

                    // Copy side images from original jobcard for duplication
                    const sideImagesToSet = {};
                    const sideKeyMap = {
                      "Front": "is_front",
                      "Right Middle": "is_right_middle",
                      "Left Middle": "is_left_middle",
                      "Back": "is_back",
                      "Velcro": "is_velcro",
                      "Visor": "is_visor",
                    };

                    // Convert existing side images to files and set in capSideImages
                    for (const [side, existingImage] of Object.entries(existingImages)) {
                      if (existingImage && existingImage.url) {
                        try {
                          const filename = existingImage.url.split("/").pop() || `jobcard_${side.replace(/\s+/g, '_')}.jpg`;
                          const file = await urlToFile(existingImage.url, filename);
                          if (file) {
                            sideImagesToSet[side] = file;
                            // Set embroidery flag to true for this side (if we successfully converted the image)
                            const flagKey = sideKeyMap[side];
                            if (flagKey) {
                              formatedValues[flagKey] = true;
                            }
                          }
                        } catch (error) {
                          console.error(`Error converting ${side} image:`, error);
                        }
                      }
                    }

                    // If no images were found in existingImages but flags are true, try to get images from jobcardImageDetail
                    if (Object.keys(sideImagesToSet).length === 0 && jobcardImageDetail && jobcardImageDetail.images) {
                      for (const img of jobcardImageDetail.images) {
                        if (img && !img.is_degitizer_image && img.side) {
                          const imageUrl = img.designer_image_url || img.designer_image;
                          if (imageUrl) {
                            try {
                              // designer_image_url from API should already be a full URL
                              const filename = imageUrl.split("/").pop() || `jobcard_${img.side.replace(/\s+/g, '_')}.jpg`;
                              const file = await urlToFile(imageUrl, filename);
                              if (file) {
                                sideImagesToSet[img.side] = file;
                                const flagKey = sideKeyMap[img.side];
                                if (flagKey) {
                                  formatedValues[flagKey] = true;
                                }
                              }
                            } catch (error) {
                              console.error(`Error converting ${img.side} image from jobcardImageDetail:`, error);
                            }
                          }
                        }
                      }
                    }

                    // Set side images in state so they get uploaded after jobcard creation
                    if (Object.keys(sideImagesToSet).length > 0) {
                      setCapSideImages(sideImagesToSet);
                    }

                    console.log("formatedValues:", formatedValues);
                    await thisfun(formatedValues, true); // duplication flag
                  }}
                >
                  Duplicate Job Card
                </Button>
              )}
            </div>

            {/* Right: Create Version */}
            {formValues && (
              <Button
                type="default"
                size="large"
                disabled={isCreationInProgress || createVersionResponseInfo.isLoading}
                loading={createVersionResponseInfo.isLoading}
                onClick={async () => {
                  if (isCreationInProgress || createVersionResponseInfo.isLoading) {
                    message.warning("Please wait for the current operation to complete.");
                    return;
                  }
                  try {
                    await createJobcardVersion(formValues.id).unwrap();
                  } catch (error) {
                    console.error("Error creating version:", error);
                  }
                }}
                style={{ borderColor: "#1890ff", color: "#1890ff", marginLeft: "auto" }}
              >
                Create Version
              </Button>
            )}
          </div>
        </Form.Item>
      </Form>

      {/* No Images Warning Modal */}
      <Modal
        title="Digitizer Images Not Uploaded"
        open={isNoImagesModalVisible}
        onOk={handleNoImagesConfirm}
        onCancel={handleNoImagesCancel}
        okText="Yes, Continue"
        cancelText="No, Upload Images"
        width={500}
        okButtonProps={{ disabled: isCreationInProgress }}
        cancelButtonProps={{ disabled: isCreationInProgress }}
      >
        <p>Digitizer images are not uploaded. Still you want to continue?</p>
        <p style={{ color: "#8c8c8c", fontSize: "12px" }}>
          If you choose "Yes, Continue", the job card will be created without digitizer images.
        </p>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        title="Confirm Job Card Submission"
        open={isModalVisible && !shouldBypassConfirmation}
        onOk={handleModalConfirm}
        onCancel={handleModalCancel}
        okText="Yes, Submit"
        cancelText="No, Cancel"
        width={500}
        okButtonProps={{ disabled: isCreationInProgress }}
        cancelButtonProps={{ disabled: isCreationInProgress }}
      >
        <p>Do you want to submit this job card?</p>
        <p style={{ color: "#8c8c8c", fontSize: "12px" }}>
          This will create the job card and upload any selected images.
        </p>
      </Modal>

      {/* Out of Stock Modal */}
      <OutOfStockModal
        visible={outOfStockModal.visible}
        fabricName={outOfStockModal.fabricName}
        colorName={outOfStockModal.colorName}
        colorValue={outOfStockModal.colorValue}
        onClose={() => setOutOfStockModal({ ...outOfStockModal, visible: false })}
      />

    </Style>
  ) : (
    <Loader />
  );
};

const Style = styled.div`
	padding: 1rem;
	position: relative;
	
	.loader {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #fff;
		padding: 1rem;
		z-index: 999;
	}
	
	/* Full-screen overlay for creation process */
	.creation-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10000;
		display: flex;
		justify-content: center;
		align-items: center;
		pointer-events: all;
	}
	
	.overlay-backdrop {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.3);
		backdrop-filter: blur(4px);
		-webkit-backdrop-filter: blur(4px);
	}
	
	.overlay-loader {
		position: relative;
		z-index: 10001;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
	}
	
	.loading-text {
		margin: 0;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		text-align: center;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	}
	.section {
		/* width: fit-content; */
		margin-bottom: 20px;
		border: 1px solid #00000068;
		.title {
			padding: 1rem;
		}
	}
	.sub-section {
		border: 1px solid #d9d9d9;
		border-radius: 6px;
		margin: 1rem;
		padding: 16px;
		// background: #fafafa;

		.title {
			font-weight: 600;
			margin-bottom: 16px;
			color: #262626;
			border-bottom: 1px solid #e8e8e8;
			padding-bottom: 8px;
		}
	}
`;

export default JobCardForm;
